// 进销存
<template>
    <div class="main">
        <el-row :gutter="10" class="mar_tb">
            <el-col :span="24">
                <el-card class="box-card">
                    <div slot="header" class="clearfix">
                        <i class="icon iconfont icon-danju-xiugai-tianchong" style="margin-right:2px;"></i>
                        <span style="font-size:13px;">钻石信息</span>
                    </div>
                    <div class="search-content mar_b" style="margin-top:-15px;margin-bottom:-15px;">
                        <el-form :inline="true" label-width="180px" size="mini" 
                            :model="query" class="demo-form-inline" ref="query">
                            <el-col :span="14">
                            <el-form-item prop="shape" label="形状：" label-width="60px">
                                <el-checkbox-group v-model="checkboxGroup1" size="small" @change="checkboxChange1">
                                    <el-tooltip class="item" effect="light" content="圆形" placement="top-start">
                                        <el-checkbox-button label="圆形"><span class="el-icon-round"/></el-checkbox-button>
                                    </el-tooltip>
                                    <el-tooltip class="item" effect="light" content="公主方" placement="top-start">
                                        <el-checkbox-button label="公主方"><span class="el-icon-princess"/></el-checkbox-button>
                                    </el-tooltip>
                                    <el-tooltip class="item" effect="light" content="雷迪恩" placement="top-start">
                                        <el-checkbox-button label="雷迪恩"><span class="el-icon-radiant"/></el-checkbox-button>
                                    </el-tooltip>
                                    <el-tooltip class="item" effect="light" content="阿斯切" placement="top-start">
                                        <el-checkbox-button label="阿斯切"><span class="el-icon-asscher"/></el-checkbox-button>
                                    </el-tooltip>
                                    <el-tooltip class="item" effect="light" content="马眼" placement="top-start">
                                        <el-checkbox-button label="马眼"><span class="el-icon-marquise"/></el-checkbox-button>
                                    </el-tooltip>
                                    <el-tooltip class="item" effect="light" content="椭圆形" placement="top-start">
                                        <el-checkbox-button label="椭圆形"><span class="el-icon-oval"/></el-checkbox-button>
                                    </el-tooltip>
                                    <el-tooltip class="item" effect="light" content="祖母绿" placement="top-start">
                                        <el-checkbox-button label="祖母绿"><span class="el-icon-emerald"/></el-checkbox-button>
                                    </el-tooltip>
                                    <el-tooltip class="item" effect="light" content="梨形" placement="top-start">
                                        <el-checkbox-button label="梨形"><span class="el-icon-pear1"/></el-checkbox-button>
                                    </el-tooltip>
                                    <el-tooltip class="item" effect="light" content="心形" placement="top-start">
                                        <el-checkbox-button label="心形"><span class="el-icon-heart"/></el-checkbox-button>
                                    </el-tooltip>
                                    <el-tooltip class="item" effect="light" content="垫形" placement="top-start">
                                        <el-checkbox-button label="垫形"><span class="el-icon-cushion"/></el-checkbox-button>
                                    </el-tooltip>
                                    <el-tooltip class="item" effect="light" content="其他" placement="top-start">
                                        <el-checkbox-button label="其他"><span class="el-icon-others"/></el-checkbox-button>
                                    </el-tooltip>
                                    <el-tooltip class="item" effect="light" content="三角形" placement="top-start">
                                        <el-checkbox-button label="三角形"><span class="el-icon-triangle"/></el-checkbox-button>
                                    </el-tooltip>
                                </el-checkbox-group>
                            </el-form-item><br>
                            <el-form-item prop="col" label="颜色：" label-width="60px" style="margin-top:-15px">
                                <el-checkbox-group v-model="checkboxGroup2" size="small" @change="checkboxChange2">
                                    <el-checkbox-button v-for="color in colorlist" :label="color" :key="color">{{color}}</el-checkbox-button>
                                </el-checkbox-group>
                            </el-form-item><br>
                            <el-form-item prop="cla" label="净度：" label-width="60px" style="margin-top:-15px">
                                <el-checkbox-group v-model="checkboxGroup3" size="small" @change="checkboxChange3">
                                    <el-checkbox-button v-for="cla in clalist" :label="cla" :key="cla">{{cla}}</el-checkbox-button>
                                </el-checkbox-group>
                            </el-form-item><br>
                            <el-form-item prop="cut" label="切工：" label-width="60px" style="margin-top:-15px">
                                <el-checkbox-group v-model="checkboxGroup4" size="small" @change="checkboxChange4">
                                    <el-checkbox-button v-for="cut in cutlist" :label="cut" :key="cut">{{cut}}</el-checkbox-button>
                                </el-checkbox-group>
                            </el-form-item>
                            <el-form-item prop="3EX" label="" label-width="60px" style="margin-top:-15px;float:right;margin-right:150px">
                                <el-button type="primary" @click="select3exn" size="small">3EX-N</el-button>
                            </el-form-item>
                            <br>
                            <el-form-item prop="pol" label="抛光：" label-width="60px" style="margin-top:-15px">
                                <el-checkbox-group v-model="checkboxGroup5" size="small" @change="checkboxChange5">
                                    <el-checkbox-button v-for="pol in pollist" :label="pol" :key="pol">{{pol}}</el-checkbox-button>
                                </el-checkbox-group>
                            </el-form-item>
                            <el-form-item prop="3VG" label="" label-width="60px" style="margin-top:-15px;float:right;margin-right:150px">
                                <el-button type="primary" @click="select3vgn" size="small">3VG-N</el-button>
                            </el-form-item>
                            <br>
                            <el-form-item prop="sym" label="对称：" label-width="60px" style="margin-top:-15px">
                                <el-checkbox-group v-model="checkboxGroup6" size="small" @change="checkboxChange6">
                                    <el-checkbox-button v-for="sym in pollist" :label="sym" :key="sym">{{sym}}</el-checkbox-button>
                                </el-checkbox-group>
                            </el-form-item>
                            <el-form-item prop="3GD" label="" label-width="60px" style="margin-top:-15px;float:right;margin-right:150px">
                                <el-button type="primary" @click="select3gdn" size="small">3GD-N</el-button>
                            </el-form-item>
                            <br>
                            <el-form-item prop="fl" label="荧光：" label-width="60px" style="margin-top:-15px">
                                <el-checkbox-group v-model="checkboxGroup7" size="small" @change="checkboxChange7">
                                    <el-checkbox-button v-for="fl in fllist" :label="fl" :key="fl">{{fl}}</el-checkbox-button>
                                </el-checkbox-group>
                            </el-form-item></br>
                            <el-form-item prop="cert" label="证书：" label-width="60px" style="margin-top:-15px">
                                <el-checkbox-group v-model="checkboxGroup8" size="small" @change="checkboxChange8">
                                    <el-checkbox-button v-for="cert in certlist" :label="cert" :key="cert">{{cert}}</el-checkbox-button>
                                </el-checkbox-group>
                            </el-form-item>
                            <el-form-item class="search-but" style="float:right;margin-top:-15px;margin-right:120px">
                                <el-button type="primary" @click="selectDiamondInfoList">查询</el-button>
                                <el-button @click="resetForm('query')">重置</el-button>
                            </el-form-item>
                            </br>
                            <!--
                            <el-form-item prop="rate" label="汇率：" label-width="90px" style="margin-top:-15px">
                                {{ ratevalue }}
                            </el-form-item>
                            
                            <el-form-item prop="rate" label="" label-width="90px" style="margin-top:-15px">
                                <el-button type="primary" @click="dialogTableVisible11 = true" size="small">调整汇率</el-button>
                            </el-form-item>
                            -->
                        </el-col>
                        <el-col :span="10">
                            <el-form-item prop="ct" label="重量：" label-width="90px">
                                <el-select v-model="query.ct" placeholder="请选择重量" clearable
                                        @blur="ctSelect" @change="ctChange" filterable allow-create style="width:180px">
                                        <el-option label="0.30-0.39" value="3"></el-option>
                                        <el-option label="0.40-0.49" value="4"></el-option>
                                        <el-option label="0.50-0.59" value="5"></el-option>
                                        <el-option label="0.60-0.69" value="6"></el-option>
                                        <el-option label="0.70-0.79" value="7"></el-option>
                                        <el-option label="0.80-0.89" value="8"></el-option>
                                        <el-option label="0.90-0.99" value="9"></el-option>
                                        <el-option label="1.00-1.09" value="10"></el-option>
                                        <el-option label="1.10-1.49" value="11"></el-option>
                                        <el-option label="1.50-1.99" value="12"></el-option>
                                        <el-option label="2.00-2.99" value="13"></el-option>
                                        <el-option label="3.00-3.99" value="14"></el-option>
                                        <el-option label="4.00-4.99" value="15"></el-option>
                                        <el-option label="5.00-10.00" value="16"></el-option>
                                </el-select>
                                <el-input v-model="query.ct3" placeholder="请输入" style="width:80px" @change="ctChange3"></el-input>
                                -<el-input v-model="query.ct4" placeholder="请输入" style="width:80px" @change="ctChange4"></el-input>
                            </el-form-item><br>
                            <!--
                            <el-form-item prop="ct" label="" label-width="80px">
                                <el-input v-model="query.ct2" placeholder="请输入"></el-input>
                            </el-form-item>-->
                            <el-form-item prop="cert_no" label="证书号：" label-width="90px" style="margin-top:-15px">
                                <el-input v-model="query.cert_no" placeholder="请输入" style="width:180px"></el-input>
                            </el-form-item>
                            <el-form-item prop="stock_id" label="货号：" label-width="90px" style="margin-top:-15px">
                                <el-input v-model="query.stock_id" placeholder="请输入" style="width:180px"></el-input>
                            </el-form-item>
                            <br>
                            <el-form-item prop="place" label="地点：" label-width="90px" style="margin-top:-15px">
                                <el-checkbox-group v-model="checkboxGroup12" size="small" @change="checkboxChange12">
                                    <el-checkbox-button v-for="item in placeList" :label="item.value" :key="item.value">{{item.value}}</el-checkbox-button>
                                </el-checkbox-group>
                                <!--
                                <el-select v-model="query.place" placeholder="请选择" clearable style="width:220px">
                                    <el-option v-for="item in placeList" :key="item.value" :label="item.value" :value="item.value"></el-option>
                                </el-select>
                                -->
                            </el-form-item><br>
                            <!--
                            <el-form-item prop="ispay" label="是否付款：" label-width="90px" style="margin-top:-15px">
                                <el-select v-model="query.ispay" placeholder="请选择">
                                    <el-option label="全部" value=""></el-option>
                                    <el-option label="已付款" value="1"></el-option>
                                    <el-option label="未付款" value="2"></el-option>
                                </el-select>
                            </el-form-item><br>-->
                            <el-form-item prop="sale_status" label="钻石状态：" label-width="90px" style="margin-top:-15px">
                                <el-checkbox-group v-model="checkboxGroup9" size="small" @change="checkboxChange9">
                                    <el-checkbox-button v-for="item in sale_statusList" :label="item.value" :key="item.value">{{item.value}}</el-checkbox-button>
                                </el-checkbox-group>
                            </el-form-item><br>
                            <!--
                            <el-form-item prop="inv_status" label="库存状态：" label-width="90px" style="margin-top:-15px">
                                <el-checkbox-group v-model="checkboxGroup11" size="small" @change="checkboxChange11">
                                    <el-checkbox-button v-for="item in inv_statusList" :label="item.value" :key="item.value">{{item.value}}</el-checkbox-button>
                                </el-checkbox-group>
                            </el-form-item><br>
                            -->
                            
                            <el-form-item prop="buy_date" label="采购日期：" label-width="90px" style="margin-top:-15px">
                                <el-date-picker v-model="query.buy_date" type="datetimerange" value-format="yyyy-MM-dd" format="yyyy-MM-dd"
                                    range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
                                </el-date-picker>
                            </el-form-item><br>
                            <el-form-item prop="deal_date" label="出库日期：" label-width="90px" style="margin-top:-15px">
                                <el-date-picker v-model="query.deal_date" type="datetimerange" value-format="yyyy-MM-dd" format="yyyy-MM-dd"
                                    range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
                                </el-date-picker>
                            </el-form-item><br>
                            <el-form-item prop="supplier" label="供应商：" label-width="90px" style="margin-top:-15px">
                                <el-input v-model="query.supplier" placeholder="请输入" style="width:150px"></el-input>
                            </el-form-item>
                            <el-form-item prop="remark" label="备注：" label-width="90px" style="margin-top:-15px">
                                <el-input v-model="query.remark" placeholder="请输入" style="width:150px"></el-input>
                            </el-form-item><br>
                            <el-form-item prop="max_meas" label="最大直径：" label-width="90px" style="margin-top:-15px">
                                <el-input v-model="query.max_meas1" placeholder="请输入" style="width:80px"></el-input>
                                -<el-input v-model="query.max_meas2" placeholder="请输入" style="width:80px"></el-input>
                            </el-form-item>
                            <el-form-item prop="min_meas" label="最小直径：" label-width="90px" style="margin-top:-15px">
                                <el-input v-model="query.min_meas1" placeholder="请输入" style="width:80px"></el-input>
                                -<el-input v-model="query.min_meas2" placeholder="请输入" style="width:80px"></el-input>
                            </el-form-item>
                            </el-col>
                        </el-form>
                    </div>
                </el-card>
            </el-col>
        </el-row>
        <el-row :gutter="10" class="mar_tb" sytle="height:30px">
            <el-col :span="24">
                <el-card class="box-card">
                    <div class="text e-info auto-table">
                        <el-button type="primary" @click="selectCertno" size="small" :disabled="isAble">获取证书号</el-button>
                        <el-button type="primary" @click="exportSelect" :disabled="isAble" size="small">导出选中</el-button>
                        <el-button type="primary" @click="selectAllListCSV" size="small">导出全部</el-button>
                        <el-button type="success" @click="dialogTableVisible001 = true" size="small">上传进销存</el-button>
                        <el-button type="primary" @click="checkRap" size="small" :disabled="isAble">检查RAP</el-button>
                        <!--<el-button type="success" @click="exportExcelCZTJFileTemplate" size="small">导出查钻调价文件</el-button>
                        <el-button type="success" @click="exportExcelCZFileTemplate" size="small">导出查钻文件</el-button>
                        -->
                        <!--<el-button type="success" @click="exportExcelRapnetFileTemplate" size="small">导出rapnet文件</el-button>-->
                        <!--<el-button type="success" @click="exportRapnetFileOne" size="small">导出rapnet文件</el-button>-->
                        <el-button type="primary" @click="dialogTableVisible13 = true" :disabled="isUPAble" size="small">更新参数</el-button>
                        <el-button type="success" @click="dialogTableVisible14 = true" :disabled="isAble" size="small">上架SZ钻石销售</el-button>
                        <!--<el-button type="primary" @click="dialogTableVisible6 = true" size="small" :disabled="isAble">调价</el-button>
                        <el-button type="primary" @click="dialogTableVisible2 = true" size="small" :disabled="isAble">修改地点</el-button>
                        <el-button type="primary" @click="dialogTableVisible5 = true" size="small" :disabled="isAble">到货日</el-button>
                        <el-button type="primary" @click="dialogTableVisible1 = true" size="small" :disabled="isAble">上下架</el-button>-->
                        <!--<el-button type="primary" @click="dialogTableVisible3 = true" size="small" :disabled="isAble">生成订单</el-button>-->
                        <!--<el-button type="primary" @click="dialogTableVisible4 = true" size="small" :disabled="isAble">借货</el-button>
                        <el-button type="primary" @click="dialogTableVisible9 = true" size="small" :disabled="isAble">全款借货</el-button>-->
                        <!--<el-button type="primary" @click="dialogTableVisible7 = true" size="small" :disabled="isAble">钻石报价</el-button>
                        <el-button type="primary" @click="dialogTableVisible12 = true" size="small" :disabled="isAble">修改库存状态</el-button>
                        <el-button type="success" @click="uploadRapnetFile" size="small">一键上传rapnet</el-button>-->
                        <el-button type="success" @click="dialogTableVisible17 = true" size="small">更新RAP报价</el-button>
                        <el-button type="primary" @click="dialogTableVisible18 = true" :disabled="isAble" size="small">上架HK钻石销售</el-button>
                        <!--
                        <el-button type="danger" @click="dialogTableVisible16 = true" size="small">上传RAP报价</el-button>
                        <el-button type="danger" @click="dialogTableVisible15 = true" size="small">更新RAP报价</el-button>
                        -->
                        <el-button type="warning" @click="dialogTableVisible8 = true" size="small" :disabled="isAble">删除选中<i class="el-icon-delete el-icon--right"></i></el-button>
                        <el-button type="success" @click="dialogTableVisible23 = true" :disabled="isAble" size="small">SZ上架HK钻石销售</el-button>
                    </div>
                </el-card>
            </el-col>
        </el-row>
        <el-row :gutter="10" class="mar_tb" sytle="height:30px;">
            <el-col :span="24">
                <el-card class="box-card">
                    <!--分页-->
                    <div class="block tar mar_t">
                        <div class="text e-info auto-table">
                            <span style='float:left;font-size:18px'> 已选：{{data_len}}； 总克重：{{ ct_total }}； 总售价：${{ sale_usd_total }},￥{{ sale_price_total }} ；RMB成本：{{ cost_total }}</span>
                        </div>
                        <el-pagination @size-change="sizeChange" @current-change="pageChange" :current-page="pager.page"
                                       :page-sizes="[20, 50, 100, 200, 500, 1000]" :page-size="pager.rows"
                                       layout="total,sizes, prev, pager, next, jumper"
                                       :total="pager.total"></el-pagination>
                    </div>
                    <div class="text e-info auto-table">
                        <el-table :data="diamondInfoList" stripe
                            @selection-change="selectionLineChangeHandle" @sort-change="sortTableFun"
                            ref="refTable" @expand-change="expandChange"
                            :header-cell-style="{background:'#eef1f6',color:'black',fontSize:'10px',padding:'0 0',margin:'0 0'}" 
                            :row-style="{height:'10px',color:'black',fontSize:'11px',padding:'0 0',margin:'0 0'}">
                            <!--
                            <el-table-column type="expand" width="40px">
                                <template slot-scope="scope">
                                    <el-table :data="diamondLog">
                                        <el-table-column align="center" min-width="6%" prop="op_action" label="操作"></el-table-column>
                                        <el-table-column align="center" min-width="6%" prop="op_before" label="操作前"></el-table-column>
                                        <el-table-column align="center" min-width="6%" prop="op_after" label="操作后"></el-table-column>
                                        <el-table-column align="center" min-width="6%" prop="user_id" label="操作人"></el-table-column>
                                        <el-table-column align="center" min-width="6%" prop="op_time" label="操作时间" :formatter="formatterDate"></el-table-column>
                                    </el-table>
                                </template>
                            </el-table-column>
                            -->
                            <el-table-column type="selection" width="40px" align="center" ></el-table-column>
                            <el-table-column align="center" mwidth="80" prop="image_link" label="图片" show-overflow-tooltip>
                                <template slot-scope="scope">
                                    <div>
                                        <el-image fit="contain" style="height:20px" v-if="scope.row.image_link !== '' || !scope.row.image_link" lazy
                                            :src="scope.row.image_link" :preview-src-list="[scope.row.image_link]">
                                        </el-image>
                                        <div v-if="scope.row.vedio_link" @click="openVideoDialog(scope.row.vedio_link)" style="cursor:pointer">
                                            <i class="el-icon-camera" style="font-size: 20px; color: #409EFF;"></i>
                                        </div>
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column align="center" width="75" prop="cert_no" label="证书号"></el-table-column>
                            <el-table-column align="center" width="50" prop="place" label="地点"></el-table-column>
                            <el-table-column align="center" width="80" prop="buy_date" label="采购日期"></el-table-column>
                            <!--<el-table-column align="center" width="80" prop="storage_date" label="入库日期"></el-table-column>-->
                            <el-table-column align="center" width="80" prop="deal_date" label="出库日期" :formatter="formatterDate"></el-table-column>

                            <el-table-column align="center" width="60" prop="supplier" label="供应商">
                                <template slot-scope="scope">
                                    {{ scope.row.supplier }}<br>
                                    <el-link :href="scope.row.image_link_yuan" target="_blank" type="primary" v-if="scope.row.image_link_yuan">
                                        <i class="el-icon-picture" style="font-size: 20px; color: #409EFF;"></i>
                                    </el-link>
                                    <el-link :href="scope.row.vedio_link_yuan" target="_blank" type="primary" v-if="scope.row.vedio_link_yuan">
                                        <i class="el-icon-video-camera" style="font-size: 20px; color: #409EFF;"></i>
                                    </el-link>
                                </template>
                            </el-table-column>
                            <!--
                            <el-table-column align="center" width="75" prop="image_link" label="供应商图片/视频" show-overflow-tooltip>
                                <template slot-scope="scope">
                                    <el-link :href="scope.row.image_link_yuan" target="_blank" type="primary" v-if="scope.row.image_link_yuan">
                                        <i class="el-icon-picture" style="font-size: 20px; color: #409EFF;"></i>
                                    </el-link>
                                    <el-link :href="scope.row.vedio_link_yuan" target="_blank" type="primary" v-if="scope.row.vedio_link_yuan">
                                        <i class="el-icon-video-camera" style="font-size: 20px; color: #409EFF;"></i>
                                    </el-link>
                                </template>
                            </el-table-column>
                            -->
                            <el-table-column align="center" width="60" prop="remark" label="备注"></el-table-column>
                            <el-table-column align="center" width="60" prop="inv_status" label="库存状态"></el-table-column>
                            <el-table-column align="center" width="60" prop="sale_status" label="钻石状态"></el-table-column>

                            <el-table-column align="center" width="70" prop="para" label="货型"></el-table-column>
                            <el-table-column align="center" width="50" prop="carat_range" label="分数段"></el-table-column>
                            <el-table-column align="center" width="50" prop="shape" label="形状"></el-table-column>
                            <el-table-column align="center" width="50" prop="ct" label="重量" :render-header="renderHeader" sortable></el-table-column>
                            <el-table-column align="center" width="50" prop="col" label="颜色"></el-table-column>
                            <el-table-column align="center" width="50" prop="cla" label="净度"></el-table-column>
                            <el-table-column align="center" width="50" prop="cut" label="切工"></el-table-column>
                            <el-table-column align="center" width="50" prop="pol" label="抛光"></el-table-column>
                            <el-table-column align="center" width="50" prop="sym" label="对称"></el-table-column>
                            <el-table-column align="center" width="50" prop="fl" label="荧光"></el-table-column>
                            
                            <el-table-column align="center" width="60" prop="cost_rap" label="成本Rap"></el-table-column>
                            <el-table-column align="center" width="60" prop="cost_dis" label="成本折扣"></el-table-column>
                            <el-table-column align="center" width="60" prop="cost" label="货品成本"></el-table-column>
                            <el-table-column align="center" width="60" prop="point" label="综合费点"></el-table-column>
                            <el-table-column align="center" width="60" prop="usd_cost" label="成本美金"></el-table-column>
                            <el-table-column align="center" width="65" prop="rmb_cost" label="成本RMB"></el-table-column>

                            <el-table-column align="center" width="65" prop="sale_rap" label="销售Rap"></el-table-column>
                            <el-table-column align="center" width="70" prop="new_dis" label="销售折扣" :render-header="renderHeader"  sortable></el-table-column>
                            <!--
                            <el-table-column align="center" width="100" prop="sale_usd" label="销售USD" show-overflow-tooltip>
                                <template slot-scope="scope">
                                    <span v-show="scope.row.place!=='SZ' && scope.row.place!=='SH' && scope.row.place!=='CH'">{{ scope.row.sale_usd }}</span>
                                </template>
                            </el-table-column>
                            -->
                            <el-table-column align="center" width="70" prop="sale_usd" label="销售USD" show-overflow-tooltip></el-table-column>
                            <el-table-column align="center" width="75" prop="sale_price" label="销售RMB" :render-header="renderHeader"  sortable show-overflow-tooltip></el-table-column>
                            <el-table-column align="center" width="70" prop="sale_rate" label="销售汇率"></el-table-column>

                            <el-table-column align="center" width="70" prop="received_rmb" label="实收RMB"></el-table-column>
                            <el-table-column align="center" width="70" prop="income" label="利润"></el-table-column>
                            <el-table-column align="center" width="70" prop="profit_rate" label="应收利润率"></el-table-column>
                            <el-table-column align="center" width="80" prop="clients" label="客户"></el-table-column>

                            <el-table-column align="center" width="50" prop="cert" label="证书"></el-table-column>
                            <el-table-column align="center" width="50" prop="year" label="年份"></el-table-column>
                            <el-table-column align="center" width="60" prop="rating" label="评价"></el-table-column>

                            <el-table-column align="center" width="100" prop="meas" label="尺寸" :render-header="renderHeader" sortable></el-table-column>
                            <el-table-column align="center" width="100" prop="max_meas" label="最大直径" :render-header="renderHeader" sortable></el-table-column>
                            <el-table-column align="center" width="100" prop="min_meas" label="最小直径" :render-header="renderHeader" sortable></el-table-column>
                            <el-table-column align="center" width="100" prop="high_meas" label="深度" :render-header="renderHeader" sortable></el-table-column>
                            <el-table-column align="center" width="60" prop="table1" label="台面"></el-table-column>

                            <el-table-column align="center" width="100" prop="stock_id" label="货号"></el-table-column>
                            <el-table-column align="center" width="60" prop="depth" label="全深"></el-table-column>
                            <el-table-column align="center" width="60" prop="ratio" label="比例"></el-table-column>
                            <!--
                            <el-table-column align="center" min-width="6%" prop="ec" label="EC"></el-table-column>
                            <el-table-column align="center" min-width="6%" prop="bt" label="BT"></el-table-column>
                            <el-table-column align="center" min-width="6%" prop="bs" label="BS"></el-table-column>
                            -->
                            <!--
                            <el-table-column align="center" width="100" prop="data_date" label="数据日期"></el-table-column>-->
                            <el-table-column align="center" width="100" prop="caozuo" label="操作">
                                <template slot-scope="scope">
                                    <el-button type="primary" @click="selectList(scope.row)" 
                                    size="mini">修改</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </el-card>
            </el-col>
        </el-row>
        <!--操作按钮部分dialog 获取证书号-->
        <div class="text e-info auto-table">
            <el-dialog title="证书号" :visible.sync = "dialogTableVisible" @close="closeSava" 
                width="600px" center :close-on-click-modal="false">
                <el-form :inline="true" label-width="150px" size="mini" 
                    :model="addDataForm2" class="demo-form-inline" ref="addDataForm2" :rules="rules">
                    <el-form-item prop="remark">
                        <el-input type="textarea" :autosize="{minRows:5, maxRows:10}" style="width:550px;"
                            placeholder="请输入内容" v-model="certnoStr">
                        </el-input>
                    </el-form-item>
                </el-form>
            </el-dialog>
        </div>
        <div class="text e-info auto-table">
            <el-dialog title="上下架" :visible.sync = "dialogTableVisible1" @close="closeSava" 
                width="600px" center :close-on-click-modal="false">
                <el-form :inline="true" label-width="150px" size="small" 
                    :model="addDataForm2" class="demo-form-inline" ref="addDataForm2" :rules="rules2">
                    <el-form-item prop="sale_status" label="批量上下架：">
                        <!--<el-select v-model="addDataForm3.sale_status" placeholder="请选择">
                            <el-option v-for="item in sale_statusList" 
                                :key="item.value" :label="item.value" :value="item.value"></el-option>
                        </el-select>-->
                        <el-radio v-model="addDataForm2.sale_status" label="1">上线</el-radio>
                        <el-radio v-model="addDataForm2.sale_status" label="2">下线</el-radio>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="savaDataParams1">保存并提交</el-button>
                </div>
            </el-dialog>
        </div>
        <div class="text e-info auto-table">
            <el-dialog title="更新参数" :visible.sync = "dialogTableVisible13" @close="closeSava" 
                width="1000px" center :close-on-click-modal="false">
                <el-form :inline="true" label-width="150px" size="small" 
                    :model="addDataForm2" class="demo-form-inline" ref="addDataForm2">
                    <el-form-item prop="remark">
                        <span style='float:left;font-size:14px'>以"证书号"来更新其他参数，允许批量更新参数如下：</span><br>
                        <span style='float:left;font-size:14px'>
                            采购时间,出库时间,库存状态,销售状态,地点,分数段,形状,重量,颜色,净度,切工,抛光,对称,荧光,证书,年份,货型
                            ,尺寸,最大直径,最小直径,深度,尺寸等级,台面,全深,比例,销售rap,新折扣,成本,成本美金,实收,利润,应收利润率,图片,视频,供应商图片,供应商视频
                            ,评价,备注,溯源码,净度等级,证书日期
                            ,BT,BS,WT,WS,CLT,CS,EC,MILK,BR,GR
                        </span>
                        <el-input type="textarea" :rows="8" style="width:900px;"
                            placeholder="请输入内容" v-model="addDataForm.remark">
                        </el-input>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="savaDataParams13">保存并提交</el-button>
                </div>
            </el-dialog>
        </div>
        <div class="text e-info auto-table">
            <el-dialog title="修改地点" :visible.sync = "dialogTableVisible2" @close="closeSava" 
                width="600px" center :close-on-click-modal="false">
                <el-form :inline="true" label-width="150px" size="small" 
                    :model="addDataForm2" class="demo-form-inline" ref="addDataForm2" :rules="rules2">
                    <el-form-item prop="place" label="批量设置地点：">
                        <el-select v-model="addDataForm2.place" placeholder="请选择">
                            <el-option v-for="item in placeList" :key="item.value" :label="item.value" :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="savaDataParams1">保存并提交</el-button>
                </div>
            </el-dialog>
        </div>
        <!-- 
            action="https://mn.ldsgia.com/ldspj/financial/uploadJXCFile"
            action="http://192.168.110.145:8080/ldspj/financial/uploadJXCFile"
         -->
        <div class="text e-info auto-table">
            <el-dialog title="上传文件" :visible.sync = "dialogTableVisible001" @close="closeSava" 
                width="1000px" center :close-on-click-modal="false">
                <div class="search-content mar_b">
                    <el-upload class="upload-demo" 
                            name = "fileList"
                            ref="upload"
                            action="https://mn.ldsgia.com/ldspj/financial/uploadJXCFile"
                            :auto-upload="false"
                            :data="{user:user}"
                            :multiple="true"
                            :before-upload="beforeUpload"
                            :on-success="handleSuccess"
                            :on-error="handleError"
                            :on-preview="handlePreview"
                            :on-remove="handleRemove">
                        <el-button type="primary" slot="trigger" size="big">选取文件</el-button>
                        <el-button type="success" @click="submitUpload" size="big">批量上传</el-button>
                        <div slot="tip" class="el-upload__tip" style="font-size:20px">只能上传xls/xlsx格式的文件</div>
                    </el-upload>
                </div>
            </el-dialog>
        </div>
        <!-- 
            action="https://mn.ldsgia.com/ldspj/financial/uploadRapFile"
            action="http://192.168.110.145:8080/ldspj/financial/uploadRapFile"
         -->
        <div class="text e-info auto-table">
            <el-dialog title="上传RAP文件" :visible.sync = "dialogTableVisible16" @close="closeSava" 
                width="1000px" top="300px" center :close-on-click-modal="false">
                <div class="search-content mar_b">
                    <el-upload class="upload-demo" 
                            name = "fileList"
                            ref="upload"
                            action="https://mn.ldsgia.com/ldspj/financial/uploadRapFile"
                            :auto-upload="false"
                            :data="{user:user}"
                            :multiple="true"
                            :before-upload="beforeUpload"
                            :on-success="handleSuccess"
                            :on-error="handleError"
                            :on-preview="handlePreview"
                            :on-remove="handleRemove">
                        <el-button type="primary" slot="trigger" size="big">选取文件</el-button>
                        <el-button type="success" @click="submitUpload" size="big">批量上传</el-button>
                        <div slot="tip" class="el-upload__tip" style="font-size:20px">只能上传xls/xlsx格式的文件</div>
                    </el-upload>
                </div>
            </el-dialog>
        </div>
        <div class="text e-info auto-table">
            <el-dialog title="更新RAP价格" :visible.sync = "dialogTableVisible17" @close="closeSava" 
                width="500px" top="300px" center :close-on-click-modal="false">
                <el-button type="danger" @click="dialogTableVisible16 = true" size="small">上传RAP文件</el-button>
                <el-button type="primary" @click="dialogTableVisible15 = true" size="small">更新深圳RAP价格</el-button>
                <el-button type="success" @click="dialogTableVisible21 = true" size="small">更新香港RAP价格</el-button>
            </el-dialog>
        </div>
        <div class="text e-info auto-table">
            <el-dialog title="批量更新深圳RAP价格" :visible.sync = "dialogTableVisible15" @close="closeSava" 
                width="600px" center :close-on-click-modal="false">
                <span>是否确认进行更新深圳RAP价格</span>
                <div slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="dialogTableVisible15 = false">取消</el-button>
                    <el-button type="primary" @click="savaDataParams8">确认</el-button>
                </div>
            </el-dialog>
        </div>
        <div class="text e-info auto-table">
            <el-dialog title="批量更新香港RAP价格" :visible.sync = "dialogTableVisible21" @close="closeSava" 
                width="600px" center :close-on-click-modal="false">
                <span>是否确认进行更新香港RAP价格</span>
                <div slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="dialogTableVisible21 = false">取消</el-button>
                    <el-button type="primary" @click="savaDataParams9">确认</el-button>
                </div>
            </el-dialog>
        </div>
        <div class="text e-info auto-table">
            <el-dialog title="生成订单" :visible.sync = "dialogTableVisible3" @close="closeSava" 
                width="600px" center :close-on-click-modal="false">
                <el-form :inline="true" label-width="150px" size="small" 
                    :model="addDataForm3" class="demo-form-inline" ref="addDataForm3" :rules="rules3">
                    <el-form-item prop="yuliu" label="选择操作：">
                        <el-radio v-model="addDataForm3.yuliu" label="1" @click.native="selectChange1($event)">预留</el-radio>
                        <el-radio v-model="addDataForm3.yuliu" label="2" @click.native="selectChange2($event)">释放</el-radio>
                    </el-form-item><br>
                    <!--<el-form-item prop="sale_rate" label="订单汇率：">
                        <el-input v-model="addDataForm3.sale_rate" placeholder="请输入" :disabled="isdisabled"></el-input>
                    </el-form-item><br>
                    <el-form-item prop="sale_back" label="订单折扣：">
                        <el-input v-model="addDataForm3.sale_back" placeholder="请输入" :disabled="isdisabled"></el-input>
                    </el-form-item><br>-->
                    <el-form-item prop="vipCount" label="客户名称：">
                        <el-input v-model="addDataForm3.vipCount" placeholder="请输入" :disabled="isdisabled"></el-input>
                    </el-form-item><br>
                    <el-form-item prop="date_long" label="预留时长：">
                        <el-input v-model="addDataForm3.date_long" placeholder="请输入" :disabled="isdisabled"></el-input>
                    </el-form-item><br>
                    <!--
                    <el-form-item prop="tiaoguo" label="">
                        <el-checkbox-group v-model="checkboxGroup10" size="small" :disabled="isdisabled">
                            <el-checkbox v-model="addDataForm3.tiaoguo" label="1">跳过已预留货品</el-checkbox>
                        </el-checkbox-group>
                    </el-form-item><br>-->
                    <el-form-item prop="remark1" label="备注信息：">
                        <el-input v-model="addDataForm3.remark1" placeholder="请输入" :disabled="isdisabled"></el-input>
                    </el-form-item><br>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="savaDataParams2">保存并提交</el-button>
                </div>
            </el-dialog>
        </div>
        <div class="text e-info auto-table">
            <el-dialog title="借货" :visible.sync = "dialogTableVisible4" @close="closeSava" 
                width="600px" center :close-on-click-modal="false">
                <el-form :inline="true" border label-width="150px" size="medium" 
                    :model="addDataForm4" class="demo-form-inline" ref="addDataForm4" :rules="rules4">
                    <el-form-item prop="islend" label="选择操作：">
                        <el-radio v-model="addDataForm4.islend" label="1" @click.native="selectChange1($event)">借货</el-radio>
                        <el-radio v-model="addDataForm4.islend" label="2" @click.native="selectChange2($event)">归还</el-radio>
                        <el-radio v-model="addDataForm4.islend" label="3" @click.native="selectChange2($event)">确认销售</el-radio>
                    </el-form-item><br>
                    <!--<el-form-item prop="sale_rate" label="订单汇率：">
                        <el-input v-model="addDataForm4.sale_rate" placeholder="请输入" :disabled="isdisabled"></el-input>
                    </el-form-item><br>
                    <el-form-item prop="sale_back" label="订单折扣：">
                        <el-input v-model="addDataForm4.sale_back" placeholder="请输入" :disabled="isdisabled"></el-input>
                    </el-form-item><br>-->
                    <el-form-item prop="vip" label="客户名称：">
                        <el-input v-model="addDataForm4.vip" placeholder="请输入" :disabled="isdisabled"></el-input>
                    </el-form-item><br>
                    <el-form-item prop="dateline" label="截止日期：">
                        <el-date-picker v-model="addDataForm4.dateline" type="date" value-format="yyyy-MM-dd" format="yyyy-MM-dd" placeholder="截至日期" :disabled="isdisabled"></el-date-picker>
                    </el-form-item>
                    <el-form-item prop="remark" label="备注信息：">
                        <el-input v-model="addDataForm4.remark" placeholder="请输入" :disabled="isdisabled"></el-input>
                    </el-form-item><br>
                    <!--<span>&nbsp;&nbsp;注意：未上架货品借出，只有借出者可见</span>-->
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="savaDataParams3">保存并提交</el-button>
                </div>
            </el-dialog>
        </div>
        <div class="text e-info auto-table">
            <el-dialog title="全款借货" :visible.sync = "dialogTableVisible9" @close="closeSava" 
                width="600px" center :close-on-click-modal="false">
                <el-form :inline="true" border label-width="150px" size="medium" 
                    :model="addDataForm3" class="demo-form-inline" ref="addDataForm3" :rules="rules3">
                    <el-form-item prop="islend" label="选择操作：">
                        <el-radio v-model="addDataForm3.islend" label="1" @click.native="selectChange1($event)">全款借货</el-radio>
                        <el-radio v-model="addDataForm3.islend" label="2" @click.native="selectChange2($event)">归还</el-radio>
                    </el-form-item><br>
                    <!--<el-form-item prop="sale_rate" label="订单汇率：">
                        <el-input v-model="addDataForm3.sale_rate" placeholder="请输入" :disabled="isdisabled"></el-input>
                    </el-form-item><br>
                    <el-form-item prop="sale_back" label="订单折扣：">
                        <el-input v-model="addDataForm3.sale_back" placeholder="请输入" :disabled="isdisabled"></el-input>
                    </el-form-item><br>-->
                    <el-form-item prop="clients" label="客户名称：">
                        <el-input v-model="addDataForm3.clients" placeholder="请输入" :disabled="isdisabled"></el-input>
                    </el-form-item><br>
                    <el-form-item prop="remark2" label="备注信息：">
                        <el-input v-model="addDataForm3.remark2" placeholder="请输入" :disabled="isdisabled"></el-input>
                    </el-form-item><br>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="savaDataParams6">保存并提交</el-button>
                </div>
            </el-dialog>
        </div>
        <div class="text e-info auto-table">
            <el-dialog title="到货日" :visible.sync = "dialogTableVisible5" @close="closeSava" 
                width="600px" center :close-on-click-modal="false">
                <el-form :inline="true" label-width="150px" size="medium" 
                    :model="addDataForm2" class="demo-form-inline" ref="addDataForm2" :rules="rules2">
                    <el-form-item prop="upload_date" label="到货日期：">
                        <el-date-picker v-model="addDataForm2.upload_date" type="date" value-format="yyyy-MM-dd" format="yyyy-MM-dd" placeholder="到货日期"></el-date-picker>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="savaDataParams1">保存并提交</el-button>
                </div>
            </el-dialog>
        </div>
        <div class="text e-info auto-table">
            <el-dialog title="调价" :visible.sync = "dialogTableVisible6" @close="closeSava" 
                width="600px" center :close-on-click-modal="false">
                <el-form :inline="true" label-width="150px" size="medium" 
                    :model="addDataForm5" class="demo-form-inline" ref="addDataForm5" :rules="rules5">
                    <el-form-item prop="tiaodian1" label="批量调点：" label-width="90px">
                        <el-radio v-model="addDataForm5.tiaodian1" label="1">+加点</el-radio>
                        <el-radio v-model="addDataForm5.tiaodian1" label="2">-减点</el-radio>
                        <el-radio v-model="addDataForm5.tiaodian1" label="3">=至点</el-radio>
                    </el-form-item><br>
                    <el-form-item prop="new_dis" label="" label-width="90px">
                        <el-input v-model="addDataForm5.new_dis" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item prop="%" label="">
                        <span>%</span>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="savaDataParams4">保存并提交</el-button>
                </div>
            </el-dialog>
        </div>
        <div class="text e-info auto-table">
            <el-dialog title="钻石报价" :visible.sync = "dialogTableVisible7" @close="closeSava" 
                width="1300px" center :close-on-click-modal="false">
                <el-form :inline="true" label-width="100px" size="mini"
                        :model="baojiaform" class="demo-form-inline" ref="baojiaform">
                    <el-button type="primary" @click="selectCertnoCopy" plain size="small">带证书号</el-button>
                    <el-button type="primary" @click="selectNoCertnoCopy" plain size="small">不带证书号</el-button>
                    <br><br>
                    <el-table border height="400" ref="refTable1" :data="dataOnLineListSelections"
                        show-summary :summary-method ="getSummaries"
                        :header-cell-style="{background:'#eef1f6',color:'#606266'}">
                        <el-table-column align="center" width="50" prop="shape" label="形状"></el-table-column>
                        <el-table-column align="center" width="50" prop="ct" label="重量"></el-table-column>
                        <el-table-column align="center" width="50" prop="col" label="颜色"></el-table-column>
                        <el-table-column align="center" width="50" prop="cla" label="净度"></el-table-column>
                        <el-table-column align="center" width="50" prop="cut" label="切工"></el-table-column>
                        <el-table-column align="center" width="50" prop="pol" label="抛光"></el-table-column>
                        <el-table-column align="center" width="50" prop="sym" label="对称"></el-table-column>
                        <el-table-column align="center" width="50" prop="fl" label="荧光"></el-table-column>
                        <el-table-column align="center" width="100" prop="sale_rap" label="rap"></el-table-column>
                        <el-table-column align="center" width="50" prop="cert" label="证书"></el-table-column>
                        <el-table-column align="center" width="150" prop="cert_no" label="证书号"></el-table-column>
                        <el-table-column align="center" width="100" prop="new_dis" label="销售折扣">
                            <template slot-scope="scope">
                                <el-form-item prop="new_dis" label-width="50px" style="margin-top:10px">
                                    <el-input v-model="scope.row.new_dis" oninput="value=value.replace(/[^-0-9.]/g,'')" 
                                        @input="handleInput1(scope.$index,scope.row.new_dis)"></el-input>
                                </el-form-item>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" width="100" prop="beilv" label="倍率">
                            <template slot-scope="scope">
                                <el-form-item prop="beilv" label-width="50px" style="margin-top:10px">
                                    <el-input v-model="scope.row.beilv" min="1" oninput="value=value.replace(/[^-0-9.]/g,'')" 
                                        @input="handleInput2(scope.$index,scope.row.beilv)"></el-input>
                                </el-form-item>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" width="100" prop="sale_rate" label="销售汇率">
                            <template slot-scope="scope">
                                <el-form-item prop="sale_rate" label-width="50px" style="margin-top:10px">
                                    <el-input v-model="scope.row.sale_rate"  oninput="value=value.replace(/[^-0-9.]/g,'')"
                                        @input="handleInput3(scope.$index,scope.row.sale_rate)"></el-input>
                                </el-form-item>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" width="120" prop="sale_price" label="RMB"></el-table-column>
                        <el-table-column align="center" width="120" prop="sale_usd" label="USD"></el-table-column>
                    </el-table>
                </el-form>
            </el-dialog>
        </div>
        <div class="text e-info auto-table">
            <el-dialog title="修改库存状态" :visible.sync = "dialogTableVisible12" @close="closeSava" 
                width="600px" center :close-on-click-modal="false">
                <el-form :inline="true" label-width="150px" size="small" 
                    :model="addDataForm2" class="demo-form-inline" ref="addDataForm2" :rules="rules2">
                    <el-form-item prop="inv_status" label="批量修改库存状态：">
                        <el-radio v-model="addDataForm2.inv_status" label="1">在库</el-radio>
                        <el-radio v-model="addDataForm2.inv_status" label="2">不在库</el-radio>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="savaDataParams12">保存并提交</el-button>
                </div>
            </el-dialog>
        </div>
        <div class="text e-info auto-table">
            <el-dialog title="批量删除" :visible.sync = "dialogTableVisible8" @close="closeSava" 
                width="600px" center :close-on-click-modal="false">
                <span>是否确认进行批量删除操作</span>
                <div slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="dialogTableVisible8 = false">取消</el-button>
                    <el-button type="primary" @click="savaDataParams5">确认</el-button>
                </div>
            </el-dialog>
        </div>
        <div class="text e-info auto-table">
            <el-dialog title="批量上架SZ" :visible.sync = "dialogTableVisible14" @close="closeSava" 
                width="600px" center :close-on-click-modal="false">
                <span>是否确认进行批量上架SZ钻石销售操作</span>
                <div slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="dialogTableVisible14 = false">取消</el-button>
                    <el-button type="primary" @click="savaDataParams31">确认</el-button>
                </div>
            </el-dialog>
        </div>
        <div class="text e-info auto-table">
            <el-dialog title="批量上架HK" :visible.sync = "dialogTableVisible18" @close="closeSava" 
                width="600px" center :close-on-click-modal="false">
                <span>是否确认进行批量上架HK钻石销售操作</span>
                <div slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="dialogTableVisible18 = false">取消</el-button>
                    <el-button type="primary" @click="savaDataParams32">确认</el-button>
                </div>
            </el-dialog>
        </div>
        <div class="text e-info auto-table">
            <el-dialog title="SZ批量上架HK" :visible.sync = "dialogTableVisible23" @close="closeSava" 
                width="600px" center :close-on-click-modal="false">
                <span style="color: red; font-size: 18px;font-weight: bold;">是否确认进行批量SZ上架HK钻石销售操作</span>
                <div slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="dialogTableVisible23 = false">取消</el-button>
                    <el-button type="primary" @click="savaDataParams33">确认</el-button>
                </div>
            </el-dialog>
        </div>
        <div class="text e-info auto-table">
            <el-dialog title="调整汇率" :visible.sync = "dialogTableVisible11" @close="closeSava" 
                width="600px" center :close-on-click-modal="false">
                <el-form :inline="true" label-width="150px" size="medium" 
                    :model="addDataForm6" class="demo-form-inline" ref="addDataForm6" :rules="rules6">
                    <el-form-item prop="rate" label="全局汇率：">
                        <el-input v-model="addDataForm6.rate" placeholder="请输入"></el-input>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="savaDataParams7">保存并提交</el-button>
                </div>
            </el-dialog>
        </div>
        <div class="text e-info auto-table">
            <el-dialog title="修改信息" :visible.sync = "dialogTableVisible10" @close="closeSava" 
                center :close-on-click-modal="false" width="1300px" top="100px">
                <el-form :inline="true" label-width="110px" size="mini" :model="addDataForm" class="demo-form-inline" ref="addDataForm" :rules="rules">
                    <!--<el-form-item prop="stock_id" label="货号：">
                        <el-input style="width:180px;" v-model="addDataForm.stock_id" placeholder="请输入"></el-input>
                    </el-form-item>-->
                    <!--<el-form-item prop="place" label="地点：">
                        <el-select v-model="addDataForm.place" placeholder="请选择" style="width:180px">
                            <el-option v-for="item in placeList" :key="item.value" :label="item.value" :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                    
                    <el-form-item prop="supplier_rapid" label="供应商rapid：">
                        <el-input style="width:180px;" v-model="addDataForm.supplier_rapid" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item prop="supplier" label="供应商：">
                        <el-input style="width:180px;" v-model="addDataForm.supplier" placeholder="请输入"></el-input>
                    </el-form-item><br>
                    -->
                    <el-form-item prop="shape" label="形状：">
                        <el-select v-model="addDataForm.shape" placeholder="请选择" style="width:180px">
                            <el-option v-for="item in shapeList" :key="item.value" :label="item.value" :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item prop="ct" label="重量：">
                        <el-input style="width:180px;" v-model="addDataForm.ct" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item prop="col" label="颜色：">
                        <el-select v-model="addDataForm.col" placeholder="请选择" style="width:180px">
                            <el-option v-for="item in colList" :key="item.value" :label="item.value" :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item prop="cla" label="净度：">
                        <el-select v-model="addDataForm.cla" placeholder="请选择" style="width:180px">
                            <el-option v-for="item in claList" :key="item.value" :label="item.value" :value="item.value"></el-option>
                        </el-select>
                    </el-form-item><br>
                    
                    <el-form-item prop="cut" label="切工：">
                        <el-select v-model="addDataForm.cut" placeholder="请选择" style="width:180px">
                            <el-option v-for="item in cutList" :key="item.value" :label="item.value" :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item prop="pol" label="抛光：">
                        <el-select v-model="addDataForm.pol" placeholder="请选择" style="width:180px">
                            <el-option v-for="item in polList" :key="item.value" :label="item.value" :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item prop="sym" label="对称：">
                        <el-select v-model="addDataForm.sym" placeholder="请选择" style="width:180px">
                            <el-option v-for="item in polList" :key="item.value" :label="item.value" :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item prop="fl" label="荧光：">
                        <el-select v-model="addDataForm.fl" placeholder="请选择" style="width:180px">
                            <el-option v-for="item in flList" :key="item.value" :label="item.value" :value="item.value"></el-option>
                        </el-select>
                    </el-form-item><br>
                    <el-form-item prop="new_dis" label="销售折扣：">
                        <el-input style="width:180px;" v-model="addDataForm.new_dis" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item prop="sale_rap" label="销售rap：">
                        <el-input style="width:180px;" v-model="addDataForm.sale_rap" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item prop="cert" label="证书：">
                        <el-select v-model="addDataForm.cert" placeholder="请选择" style="width:180px">
                            <el-option v-for="item in certList" :key="item.value" :label="item.value" :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item prop="cert_no" label="证书号：">
                        <el-input style="width:180px;" v-model="addDataForm.cert_no" placeholder="请输入"></el-input>
                        <!--<el-button type="primary" @click="selectList">查询</el-button>-->
                    </el-form-item>
                    <br><br>
                    <el-form-item prop="year" label="年份：">
                        <el-input style="width:180px;" v-model="addDataForm.year" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item prop="place" label="地点：">
                        <el-select v-model="addDataForm.place" placeholder="请选择" style="width:180px">
                            <el-option v-for="item in placeList" :key="item.value" :label="item.value" :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item prop="inv_status" label="库存状态：">
                        <el-select v-model="addDataForm.inv_status" placeholder="请选择" style="width:180px">
                            <el-option v-for="item in inv_statusList" :key="item.value" :label="item.value" :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item prop="sale_status" label="销售状态：">
                        <el-select v-model="addDataForm.sale_status" placeholder="请选择" style="width:180px">
                            <el-option v-for="item in sale_statusList" :key="item.value" :label="item.value" :value="item.value"></el-option>
                        </el-select>
                    </el-form-item><br>
                    <!--
                    <el-form-item prop="buy_date" label="采购日期：">
                        <el-date-picker style="width:180px;" type="date" placeholder="选择日期" value-format="yyyy-MM-dd" format="yyyy-MM-dd" v-model="addDataForm.buy_date"></el-date-picker>
                    </el-form-item>
                    
                    <el-form-item prop="cost_rap" label="成本rap：">
                        <el-input style="width:180px;" v-model="addDataForm.cost_rap" placeholder="请输入"></el-input>
                    </el-form-item><br>

                    <el-form-item prop="cost_dis" label="成本折扣：">
                        <el-input style="width:180px;" v-model="addDataForm.cost_dis" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item prop="cost" label="货品成本：">
                        <el-input style="width:180px;" v-model="addDataForm.cost" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item prop="point" label="综合费点：">
                        <el-input style="width:180px;" v-model="addDataForm.point" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item prop="usd_cost" label="美金成本：">
                        <el-input style="width:180px;" v-model="addDataForm.usd_cost" placeholder="请输入"></el-input>
                    </el-form-item><br>

                    <el-form-item prop="rmb_cost" label="人民币成本：">
                        <el-input style="width:180px;" v-model="addDataForm.rmb_cost" placeholder="请输入"></el-input>
                    </el-form-item>
                    -->
                    <el-form-item prop="meas" label="尺寸：">
                        <el-input style="width:180px;" v-model="addDataForm.meas" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item prop="table1" label="台面：">
                        <el-input style="width:180px;" v-model="addDataForm.table1" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item prop="depth" label="全深：">
                        <el-input style="width:180px;" v-model="addDataForm.depth" placeholder="请输入"></el-input>
                    </el-form-item>

                    <el-form-item prop="ratio" label="比例：">
                        <el-input style="width:180px;" v-model="addDataForm.ratio" placeholder="请输入"></el-input>
                    </el-form-item><br>
                    <el-form-item prop="deal_date" label="出库日期：">
                        <el-date-picker style="width:180px;" type="date" placeholder="选择日期" value-format="yyyy-MM-dd" format="yyyy-MM-dd" v-model="addDataForm.deal_date"></el-date-picker>
                    </el-form-item>
                    <el-form-item prop="cla_level" label="净度等级：">
                        <el-input style="width:180px;" v-model="addDataForm.cla_level" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item prop="rating" label="评价：">
                        <el-input style="width:180px;" v-model="addDataForm.rating" placeholder="请输入"></el-input>
                    </el-form-item>
                    <br>
                    <el-form-item prop="remark" label="备注：">
                        <el-input type="textarea" :autosize="{minRows:6, maxRows:3}" style="width:500px;"
                            placeholder="请输入内容" v-model="addDataForm.remark">
                        </el-input>
                    </el-form-item><br>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="closeSava">取 消</el-button>
                    <el-button type="primary" @click="savaDataParams">保存并提交</el-button>
                </div>
            </el-dialog>
        </div>
        <div class="text e-info auto-table">
            <el-dialog title="调价" :visible.sync = "dialogTableVisible20" @close="closeSava" 
                center :close-on-click-modal="false" width="1300px" top="100px">
                <el-form :inline="true" label-width="110px" size="mini" :model="addDataForm" class="demo-form-inline" ref="addDataForm" :rules="rules">
                    <!--<el-form-item prop="stock_id" label="货号：">
                        <el-input style="width:180px;" v-model="addDataForm.stock_id" placeholder="请输入"></el-input>
                    </el-form-item>-->
                    <!--<el-form-item prop="place" label="地点：">
                        <el-select v-model="addDataForm.place" placeholder="请选择" style="width:180px">
                            <el-option v-for="item in placeList" :key="item.value" :label="item.value" :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                    
                    <el-form-item prop="supplier_rapid" label="供应商rapid：">
                        <el-input style="width:180px;" v-model="addDataForm.supplier_rapid" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item prop="supplier" label="供应商：">
                        <el-input style="width:180px;" v-model="addDataForm.supplier" placeholder="请输入"></el-input>
                    </el-form-item><br>
                    -->
                    <el-form-item prop="shape" label="形状：">
                        <el-select v-model="addDataForm.shape" placeholder="请选择" style="width:180px">
                            <el-option v-for="item in shapeList" :key="item.value" :label="item.value" :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item prop="ct" label="重量：">
                        <el-input style="width:180px;" v-model="addDataForm.ct" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item prop="col" label="颜色：">
                        <el-select v-model="addDataForm.col" placeholder="请选择" style="width:180px">
                            <el-option v-for="item in colList" :key="item.value" :label="item.value" :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item prop="cla" label="净度：">
                        <el-select v-model="addDataForm.cla" placeholder="请选择" style="width:180px">
                            <el-option v-for="item in claList" :key="item.value" :label="item.value" :value="item.value"></el-option>
                        </el-select>
                    </el-form-item><br>
                    
                    <el-form-item prop="cut" label="切工：">
                        <el-select v-model="addDataForm.cut" placeholder="请选择" style="width:180px">
                            <el-option v-for="item in cutList" :key="item.value" :label="item.value" :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item prop="pol" label="抛光：">
                        <el-select v-model="addDataForm.pol" placeholder="请选择" style="width:180px">
                            <el-option v-for="item in polList" :key="item.value" :label="item.value" :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item prop="sym" label="对称：">
                        <el-select v-model="addDataForm.sym" placeholder="请选择" style="width:180px">
                            <el-option v-for="item in polList" :key="item.value" :label="item.value" :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item prop="fl" label="荧光：">
                        <el-select v-model="addDataForm.fl" placeholder="请选择" style="width:180px">
                            <el-option v-for="item in flList" :key="item.value" :label="item.value" :value="item.value"></el-option>
                        </el-select>
                    </el-form-item><br>
                    <el-form-item prop="new_dis" label="销售折扣：">
                        <el-input style="width:180px;" v-model="addDataForm.new_dis" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item prop="sale_rap" label="销售rap：">
                        <el-input style="width:180px;" v-model="addDataForm.sale_rap" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item prop="cert" label="证书：">
                        <el-select v-model="addDataForm.cert" placeholder="请选择" style="width:180px">
                            <el-option v-for="item in certList" :key="item.value" :label="item.value" :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item prop="cert_no" label="证书号：">
                        <el-input style="width:180px;" v-model="addDataForm.cert_no" placeholder="请输入" readonly></el-input>
                        <!--<el-button type="primary" @click="selectList">查询</el-button>-->
                    </el-form-item>
                    <!--
                    <br>
                    <el-form-item prop="new_dis" label="销售折扣：">
                        <el-input v-model="addDataForm.new_dis" oninput="value=value.replace(/[^-0-9.]/g,'')" 
                            @input="handleInput20($index,addDataForm.row.new_dis)"></el-input>
                    </el-form-item>
                    <el-form-item prop="sale_usd" label="USD：">
                        <el-input style="width:180px;" v-model="addDataForm.sale_usd" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item prop="sale_price" label="RMB：">
                        <el-input style="width:180px;" v-model="addDataForm.sale_price" placeholder="请输入"></el-input>
                    </el-form-item>
                    -->
                    <br><br>
                    <el-form-item prop="place" label="地点：">
                        <el-select v-model="addDataForm.place" placeholder="请选择" style="width:180px">
                            <el-option v-for="item in placeList" :key="item.value" :label="item.value" :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item prop="inv_status" label="库存状态：">
                        <el-select v-model="addDataForm.inv_status" placeholder="请选择" style="width:180px">
                            <el-option v-for="item in inv_statusList" :key="item.value" :label="item.value" :value="item.value" disabled></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item prop="sale_status" label="销售状态：">
                        <el-select v-model="addDataForm.sale_status" placeholder="请选择" style="width:180px">
                            <el-option v-for="item in sale_statusList" :key="item.value" :label="item.value" :value="item.value" disabled></el-option>
                        </el-select>
                    </el-form-item>
                    <!--
                    <el-form-item prop="buy_date" label="采购日期：">
                        <el-date-picker style="width:180px;" type="date" placeholder="选择日期" value-format="yyyy-MM-dd" format="yyyy-MM-dd" v-model="addDataForm.buy_date"></el-date-picker>
                    </el-form-item>
                    
                    <el-form-item prop="cost_rap" label="成本rap：">
                        <el-input style="width:180px;" v-model="addDataForm.cost_rap" placeholder="请输入"></el-input>
                    </el-form-item><br>

                    <el-form-item prop="cost_dis" label="成本折扣：">
                        <el-input style="width:180px;" v-model="addDataForm.cost_dis" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item prop="cost" label="货品成本：">
                        <el-input style="width:180px;" v-model="addDataForm.cost" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item prop="point" label="综合费点：">
                        <el-input style="width:180px;" v-model="addDataForm.point" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item prop="usd_cost" label="美金成本：">
                        <el-input style="width:180px;" v-model="addDataForm.usd_cost" placeholder="请输入"></el-input>
                    </el-form-item><br>

                    <el-form-item prop="rmb_cost" label="人民币成本：">
                        <el-input style="width:180px;" v-model="addDataForm.rmb_cost" placeholder="请输入"></el-input>
                    </el-form-item>
                    -->
                    <el-form-item prop="meas" label="尺寸：">
                        <el-input style="width:180px;" v-model="addDataForm.meas" placeholder="请输入"></el-input>
                    </el-form-item><br>
                    <el-form-item prop="table1" label="台面：">
                        <el-input style="width:180px;" v-model="addDataForm.table1" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item prop="depth" label="全深：">
                        <el-input style="width:180px;" v-model="addDataForm.depth" placeholder="请输入"></el-input>
                    </el-form-item>

                    <el-form-item prop="ratio" label="比例：">
                        <el-input style="width:180px;" v-model="addDataForm.ratio" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item prop="cla_level" label="净度等级：">
                        <el-input style="width:180px;" v-model="addDataForm.cla_level" placeholder="请输入"></el-input>
                    </el-form-item><br>
                    <el-form-item prop="remark" label="备注：">
                        <el-input type="textarea" :autosize="{minRows:6, maxRows:3}" style="width:500px;"
                            placeholder="请输入内容" v-model="addDataForm.remark">
                        </el-input>
                    </el-form-item><br>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="closeSava">取 消</el-button>
                    <el-button type="primary" @click="savaDataParams_tiaojia">保存并提交</el-button>
                </div>
            </el-dialog>
            <!-- 视频播放弹窗 -->
            <el-dialog
                title="钻石视频"
                :visible.sync="videoDialogVisible"
                width="600px"
                center
                :close-on-click-modal="true"
                :append-to-body="true">
                <div class="video-dialog-content">
                    <video-player
                        v-if="currentVideoUrl"
                        class="full-video-player" 
                        ref="fullVideoPlayer"
                        :options="getFullVideoOptions(currentVideoUrl)"
                        :playsinline="true">
                    </video-player>
                </div>
            </el-dialog>
        </div>
    </div>
</template>
<script>
    import util from '../../common/js/util.js';
    const cityOptions = ['D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M-N', 'O-Z', '<M'];
    export default {
        data() {
            let validateNumber = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请输入数字'));
                } else {
                    if (!util.isNumber(value)) {
                        callback(new Error('数字格式错误，请重新输入'));
                    }
                    callback();
                }
            };
            return {
                isAble: true,
                isUPAble: true,
                isdisabled: false,
                dialogTableVisible: false,
                dialogTableVisible1: false,
                dialogTableVisible2: false,
                dialogTableVisible3: false,
                dialogTableVisible4: false,
                dialogTableVisible5: false,
                dialogTableVisible6: false,
                dialogTableVisible7: false,
                dialogTableVisible8: false,
                dialogTableVisible9: false,
                dialogTableVisible10: false,
                dialogTableVisible11: false,
                dialogTableVisible12: false,
                dialogTableVisible13: false,
                dialogTableVisible14: false,
                dialogTableVisible15: false,
                dialogTableVisible16: false,
                dialogTableVisible17: false,
                dialogTableVisible18: false,
                dialogTableVisible20: false,
                dialogTableVisible21: false,
                dialogTableVisible23: false,
                dialogTableVisible001: false,
                fileList: [],
                user:'admin',
                checkboxGroup1: [],
                checkboxGroup2: [],
                checkboxGroup3: [],
                checkboxGroup4: [],
                checkboxGroup5: [],
                checkboxGroup6: [],
                checkboxGroup7: [],
                checkboxGroup8: [],
                checkboxGroup9: [],
                checkboxGroup10: [],
                checkboxGroup11: [],
                checkboxGroup12: [],
                shapeList1: [{'value':'round'},{'value':'princess'},{'value':'radiant'}
                            ,{'value':'asscher'},{'value':'marquise'},{'value':'oval'}
                            ,{'value':'emerald'},{'value':'pear'},{'value':'heart'}
                            ,{'value':'cushion'},{'value':'others'},{'value':'triangle'}],
                shapeList: [{'value':'圆形'},{'value':'公主方'},{'value':'雷迪恩'}
                            ,{'value':'阿斯切'},{'value':'马眼'},{'value':'椭圆形'}
                            ,{'value':'祖母绿'},{'value':'梨形'},{'value':'心形'}
                            ,{'value':'垫形'},{'value':'其他'},{'value':'三角形'}],
                colList: [{'value':'D'},{'value':'E'},{'value':'F'}
                            ,{'value':'G'},{'value':'H'},{'value':'I'}
                            ,{'value':'J'},{'value':'K'},{'value':'L'}
                            ,{'value':'M-N'},{'value':'O-Z'}],
                claList: [{'value':'FL'},{'value':'IF'},{'value':'VVS1'}
                            ,{'value':'VVS2'},{'value':'VS1'},{'value':'VS2'}
                            ,{'value':'SI1'},{'value':'SI2'},{'value':'SI3'}
                            ,{'value':'I1'},{'value':'I2'}],
                cutList: [{'value':'EX'},{'value':'VG'},{'value':'GD'}
                            ,{'value':'FR'},{'value':'PR'},{'value':'NN'}],
                polList: [{'value':'EX'},{'value':'VG'},{'value':'GD'}
                            ,{'value':'FR'},{'value':'PR'}],
                flList: [{'value':'N'},{'value':'VSL'},{'value':'F'}
                            ,{'value':'M'},{'value':'S'},{'value':'VS'}],
                placeList: [{'value':'HK'},{'value':'SZ'},{'value':'CH'}
                            ,{'value':'INDIA'},{'value':'SH'},{'value':'H-K'}],
                certList: [{'value':'GIA'},{'value':'NGTC'},{'value':'IGI'}
                            ,{'value':'HRD'},{'value':'None'},{'value':'Other'}],
                inv_statusList: [{'value':'在库'},{'value':'不在库'}],
                sale_statusList: [{'value':'在售'},{'value':'保留'},{'value':'借货'}
                            ,{'value':'全款借货'},{'value':'确认销售'},{'value':'已完成'},{'value':'参考'},{'value':'藏'},{'value':'不在库'}],
                colorlist: cityOptions,
                clalist: ['FL', 'IF', 'VVS1', 'VVS2', 'VS1', 'VS2', 'SI1', 'SI2', 'SI3','I1','I2'],
                cutlist: ['EX', 'VG', 'GD', 'FR', 'PR', 'NN'],
                pollist: ['EX', 'VG', 'GD', 'FR', 'PR'],
                fllist: ['N', 'VSL', 'F', 'M', 'S', 'VS'],
                certlist: ['GIA', 'NGTC', 'IGI'],
                status: '',
                isq: '',
                inv_status: '',
                dateList: {},
                baojiaform: {},
                addDataForm: {},
                addDataForm2: {},
                addDataForm3: {
                    'sale_status': '1',
                    'tiaodian1': '1',
                    'date_long': '24h',
                },
                addDataForm4: {},
                addDataForm5: {},
                addDataForm6: {},
                dataOnLineListSelections: [],
                certnoList: [],
                certnoAll: '',
                certnoStr: '',
                sale_priceList: [],
                sale_priceStr: '',
                idList: [],
                idStr: '',
                diamondInfoList: [],
                diamondLog: [],
                diamondAllInfoList: {},
                diamondCZInfoList: {},
                diamondRapnetInfoList: {},
                imgViewerVisible:false,
                ct_total: 0,
                data_len: 0,
                sale_rap_total: 0,
                sale_usd_total: 0,
                sale_price_total: 0,
                cost_total: 0,
                ratevalue: '',
                // 视频弹窗数据
                videoDialogVisible: false,
                currentVideoUrl: '',
                // 查询
                query: {
                    data_dt: [],
                    ct1: '',
                    ct2: '',
                },
                column: 'sale_price',
                order: 'asc',
                queryDate: '',
                // queryDate: this.getNowTime(),
                // 分页
                pager: {
                    page: 1,
                    rows: 100,
                    total: 0
                },
                rules:{
                    shape:[
                        {
                            required:true,
                            message:'请输入内容',
                            trigger:'blur'
                        }
                    ],
                    ct:[
                        {
                            required:true,
                            message:'请输入内容',
                            trigger:'blur'
                        }
                    ],
                    col:[
                        {
                            required:true,
                            message:'请输入内容',
                            trigger:'blur'
                        }
                    ],
                    cla:[
                        {
                            required:true,
                            message:'请输入内容',
                            trigger:'blur'
                        }
                    ],
                    cut:[
                        {
                            required:true,
                            message:'请输入内容',
                            trigger:'blur'
                        }
                    ],
                    pol:[
                        {
                            required:true,
                            message:'请输入内容',
                            trigger:'blur'
                        }
                    ],
                    sym:[
                        {
                            required:true,
                            message:'请输入内容',
                            trigger:'blur'
                        }
                    ],
                    fl:[
                        {
                            required:true,
                            message:'请输入内容',
                            trigger:'blur'
                        }
                    ],
                    cert:[
                        {
                            required:true,
                            message:'请输入内容',
                            trigger:'blur'
                        }
                    ],
                    cert_no:[
                        {
                            required:true,
                            message:'请输入内容',
                            trigger:'blur'
                        }
                    ],
                    sale_rap:[
                        {
                            required:true,
                            message:'请输入内容',
                            trigger:'blur'
                        }
                    ],
                    new_dis:[
                        {
                            required:true,
                            message:'请输入内容',
                            trigger:'blur'
                        }
                    ]
                },
                rules2:{
                    place:[
                        {
                            required:true,
                            message:'请选择',
                            trigger:'blur'
                        }
                    ],
                    upload_date:[
                        {
                            required:true,
                            message:'请选择日期',
                            trigger:'blur'
                        }
                    ]
                },
                rules3:{
                    vipCount:[
                        {
                            required:true,
                            message:'请输入内容',
                            trigger:'blur'
                        }
                    ],
                    date_long:[
                        {
                            required:true,
                            message:'请输入内容',
                            trigger:'blur'
                        }
                    ],
                    clients:[
                        {
                            required:true,
                            message:'请输入内容',
                            trigger:'blur'
                        }
                    ]
                },
                rules4:{
                    vip:[
                        {
                            required:true,
                            message:'请输入内容',
                            trigger:'blur'
                        }
                    ],
                    dateline:[
                        {
                            required:true,
                            message:'请输入内容',
                            trigger:'blur'
                        }
                    ]
                },
                rules5:{
                    new_dis:[
                        {
                            required:true,
                            message:'请输入',
                            trigger:'blur'
                        }
                    ]
                },
                rules6:{
                    rate:[
                        {
                            required:true,
                            message:'请输入',
                            trigger:'blur'
                        }
                    ]
                },
                rules7:{
                    new_dis:[
                        {
                            required:true,
                            message:'请输入数字',
                            trigger:'blur'
                        },
                        {
                            validator: validateNumber,
                            trigger:'blur'
                        }
                    ]
                }
            };
        },
        methods: {
            // 选择行数
            sizeChange(rows) {
                this.pager.rows = rows;
                this.selectDiamondInfoList();
            },
            // 选择页
            pageChange(page) {
                this.pager.page = page;
                this.selectDiamondInfoList();
            },
            // shape 形状
            checkboxChange1(val) {
                this.query.shape = val.join();
                //console.log(this.query.shape);
            },
            // 颜色
            checkboxChange2(val) {
                this.query.col = val.join();
                //console.log(this.query.col);
            },
            // 净度
            checkboxChange3(val) {
                this.query.cla = val.join();
                //console.log(this.query.col);
            },
            // 切工
            checkboxChange4(val) {
                this.query.cut = val.join();
                //console.log(this.query.cut);
            },
            // 抛光
            checkboxChange5(val) {
                this.query.pol = val.join();
                //console.log(this.query.pol);
            },
            // 对称
            checkboxChange6(val) {
                this.query.sym = val.join();
                //console.log(this.query.sym);
            },
            // 荧光
            checkboxChange7(val) {
                this.query.fl = val.join();
                //console.log(this.query.fl);
            },
            // 证书
            checkboxChange8(val) {
                this.query.cert = val.join();
                //console.log(this.query.cert);
            },
            // 销售状态
            checkboxChange9(val) {
                this.query.sale_status = val.join();
                //console.log(this.query.sale_status);
            },
            // 库存状态
            checkboxChange11(val) {
                this.query.inv_status = val.join();
                //console.log(this.query.inv_status);
            },
            // 地点
            checkboxChange12(val) {
                this.query.place = val.join();
                //console.log(this.query.place);
            },
            // 联动赋值重量
            ctChange(val) {
                if(val == 3) {
                    this.$set(this.query,'ct1','0.30');
                    this.$set(this.query,'ct2','0.39');
                }else if(val == 4) {
                    this.$set(this.query,'ct1','0.40');
                    this.$set(this.query,'ct2','0.49');
                }else if(val == 5) {
                    this.$set(this.query,'ct1','0.50');
                    this.$set(this.query,'ct2','0.59');
                }else if(val == 6) {
                    this.$set(this.query,'ct1','0.60');
                    this.$set(this.query,'ct2','0.69');
                }else if(val == 7) {
                    this.$set(this.query,'ct1','0.70');
                    this.$set(this.query,'ct2','0.79');
                }else if(val == 8) {
                    this.$set(this.query,'ct1','0.80');
                    this.$set(this.query,'ct2','0.89');
                }else if(val == 9) {
                    this.$set(this.query,'ct1','0.90');
                    this.$set(this.query,'ct2','0.99');
                }else if(val == 10) {
                    this.$set(this.query,'ct1','1.00');
                    this.$set(this.query,'ct2','1.09');
                }else if(val == 11) {
                    this.$set(this.query,'ct1','1.10');
                    this.$set(this.query,'ct2','1.49');
                }else if(val == 12) {
                    this.$set(this.query,'ct1','1.50');
                    this.$set(this.query,'ct2','1.99');
                }else if(val == 13) {
                    this.$set(this.query,'ct1','2.00');
                    this.$set(this.query,'ct2','2.99');
                }else if(val == 14) {
                    this.$set(this.query,'ct1','3.00');
                    this.$set(this.query,'ct2','3.99');
                }else if(val == 15) {
                    this.$set(this.query,'ct1','4.00');
                    this.$set(this.query,'ct2','4.99');
                }else if(val == 16) {
                    this.$set(this.query,'ct1','5.00');
                    this.$set(this.query,'ct2','9.99');
                }
            },
            // 手动输入重量
            ctSelect(e) {
                let value = e.target.value;
                if(value) {
                    console.log(value)
                    if(value.includes('-')){
                        this.$nextTick(()=> {
                            this.$set(this.query,'ct',value);
                        })
                        // this.query.ct = value;
                        let valArr = value.split('-');
                        this.$set(this.query,'ct1',valArr[0]);
                        this.$set(this.query,'ct2',valArr[1]);
                        console.log(this.query.ct1);
                        console.log(this.query.ct2);
                    }
                }
            },
            // 手动输入重量2
            ctChange3(value) {
                if(value) {
                    this.$set(this.query,'ct','');
                    console.log(value)
                    this.$set(this.query,'ct1',value);
                    console.log(this.query.ct1);
                }
            },
            ctChange4(value) {
                if(value) {
                    console.log(value)
                    this.$set(this.query,'ct2',value);
                    console.log(this.query.ct2);
                }
            },
            // 3EXN
            select3exn() {
                this.checkboxGroup4 = ['EX'];
                this.checkboxGroup5 = ['EX'];
                this.checkboxGroup6 = ['EX'];
                this.checkboxGroup7 = ['N'];
                this.query.cut = 'EX';
                this.query.pol = 'EX';
                this.query.sym = 'EX';
                this.query.fl = 'N';
            },
            // 3vg
            select3vgn() {
                this.checkboxGroup4 = ['EX','VG'];
                this.checkboxGroup5 = ['EX','VG'];
                this.checkboxGroup6 = ['EX','VG'];
                this.checkboxGroup7 = ['N'];
                this.query.cut = 'EX,VG';
                this.query.pol = 'EX,VG';
                this.query.sym = 'EX,VG';
                this.query.fl = 'N';
            },
            // 3gd
            select3gdn() {
                this.checkboxGroup4 = ['EX','VG','GD'];
                this.checkboxGroup5 = ['EX','VG','GD'];
                this.checkboxGroup6 = ['EX','VG','GD'];
                this.checkboxGroup7 = ['N'];
                this.query.cut = 'EX,VG,GD';
                this.query.pol = 'EX,VG,GD';
                this.query.sym = 'EX,VG,GD';
                this.query.fl = 'N';
            },
            selectChange1(el){
                if(el.target.tagName === 'INPUT') {
                    return;
                }
                this.isdisabled = false;
            },
            selectChange2(el){
                if(el.target.tagName === 'INPUT') {
                    return;
                }
                this.isdisabled = true;
            },
            // 双击展开行
            toggleExpand(row) {
                this.$refs.refTable.toggleRowExpansion(row);
            },
            // 选择器选择数据，加工数据证书号、统计数据
            selectionLineChangeHandle(val) {
                // 统计选中数量
                this.data_len = val.length;
                // 计算总销售额
                let sale_rap1 = 0;
                let sale_usd1 = 0;
                let sale_price1 = 0;
                let received_rmb1 = 0;
                let cost = 0;
                let ct1 = 0;
                for(let a = 0; a < this.data_len; a++) {
                    //console.log(val[0].sale_price);
                    //console.log(val[0].ct);
                    // 进货价
                    sale_rap1 += val[a].sale_rap;
                    // 销售价格
                    sale_usd1 += val[a].sale_usd;
                    sale_price1 += val[a].sale_price;
                    // 实收RMB
                    received_rmb1 += val[a].received_rmb;
                    // 成本
                    cost += val[a].rmb_cost;
                    // 重量
                    ct1 += parseFloat(val[a].ct);
                }
                // 进货价
                this.sale_rap_total = Math.round(sale_rap1);
                // 销售价格
                this.sale_usd_total = Math.round(sale_usd1);
                this.sale_price_total = Math.round(received_rmb1);
                // 成本
                this.cost_total = Math.round(cost);
                // 总重量
                this.ct_total = ct1.toFixed(2);
                // 选中导出数据赋值
                this.dataOnLineListSelections = val;
                this.dataOnLineListSelections.forEach(item =>{this.$set(item,'beilv',1)})
                //console.log(this.dataOnLineListSelections)
                // 复制选中数据给客户
                for(let i =0;i<this.data_len;i++){
                    console.log(val[i]);
                }
                // id、数据证书号拼接
                this.idList = val.map((item) => item.id);
                this.certnoList = val.map((item) => item.cert_no + '\n');
                this.sale_priceList = val.map((item) => item.sale_price);
                //数据选中后，显示按钮
                if(this.certnoList.length>0) {
                    this.isAble = false;
                }else{
                    this.isAble = true;
                }
                //上下架设置默认
                this.$set(this.addDataForm2,'sale_status','1');
                //预留设置默认
                this.$set(this.addDataForm3,'yuliu','1');
                // 设置默认保留时间
                this.$set(this.addDataForm3,'date_long','24h');
                //借出设置默认
                this.$set(this.addDataForm4,'islend','1');
                // 调点设置默认-点
                //this.$set(this.addDataForm5,'tiaodian1','2');
            },
            // 修改销售折扣
            handleInput1(row,val) {
                console.log(row)
                console.log(val)
                // 销售美金 = 销售rap * (1+新折扣%) *重量
                // 销售价格 = 销售美金 * 销售汇率
                //console.log(this.dataOnLineListSelections[row])
                let sale_rap = this.dataOnLineListSelections[row].sale_rap
                let sale_rate = this.dataOnLineListSelections[row].sale_rate
                let ct = this.dataOnLineListSelections[row].ct
                let beilv = this.dataOnLineListSelections[row].beilv
                let sale_usd = (sale_rap*(1+(val/100)) *ct).toFixed(2)
                let sale_price = (beilv * sale_rate * sale_usd).toFixed(2)
                console.log(sale_price)
                this.$set(this.dataOnLineListSelections[row],'sale_price',sale_price)
                this.$set(this.dataOnLineListSelections[row],'sale_usd',sale_usd)
            },
            // 修改 倍率
            handleInput2(row,val) {
                console.log(row)
                console.log(val)
                // 销售美金 = 销售rap * (1+新折扣%) *重量
                // 销售价格 = 售价 * 倍率
                //console.log(this.dataOnLineListSelections[row])
                let sale_rap = this.dataOnLineListSelections[row].sale_rap
                let sale_rate = this.dataOnLineListSelections[row].sale_rate
                let new_dis = this.dataOnLineListSelections[row].new_dis
                let ct = this.dataOnLineListSelections[row].ct
                let sale_usd = (sale_rap*(1+(new_dis/100)) *ct).toFixed(2)
                let sale_price = (sale_rate * sale_usd * val).toFixed(2)
                let sale_usd_2 = (sale_usd * val).toFixed(2)
                console.log(sale_usd)
                console.log(sale_rate)
                console.log(sale_price)
                this.$set(this.dataOnLineListSelections[row],'sale_price',sale_price)
                this.$set(this.dataOnLineListSelections[row],'sale_usd',sale_usd_2)
            },
            // 修改 汇率
            handleInput3(row,val) {
                console.log(row)
                console.log(val)
                // 销售美金 = 销售rap * (1+新折扣%) *重量
                // 销售价格 = 销售美金 * 销售汇率
                //console.log(this.dataOnLineListSelections[row])
                let sale_rap = this.dataOnLineListSelections[row].sale_rap
                let sale_rate = this.dataOnLineListSelections[row].sale_rate
                let new_dis = this.dataOnLineListSelections[row].new_dis
                let ct = this.dataOnLineListSelections[row].ct
                let beilv = this.dataOnLineListSelections[row].beilv
                let sale_usd = (sale_rap*(1+(new_dis/100)) *ct).toFixed(2)
                let sale_price = (beilv * sale_rate * sale_usd).toFixed(2)
                console.log(sale_price)
                this.$set(this.dataOnLineListSelections[row],'sale_price',sale_price)
            },
            // 修改销售折扣 调价
            handleInput20(val) {
                console.log(val)
                // 销售美金 = 销售rap * (1+新折扣%) *重量
                // 销售价格 = 销售美金 * 销售汇率
                //console.log(this.dataOnLineListSelections[row])
                let sale_rap = this.dataOnLineListSelections[row].sale_rap
                let sale_rate = this.dataOnLineListSelections[row].sale_rate
                let ct = this.dataOnLineListSelections[row].ct
                let sale_usd = (sale_rap*(1+(val/100)) *ct).toFixed(2)
                let sale_price = (beilv * sale_rate * sale_usd).toFixed(2)
                console.log(sale_price)
                //this.$set(this.dataOnLineListSelections[row],'sale_price',sale_price)
                //this.$set(this.dataOnLineListSelections[row],'sale_usd',sale_usd)
            },
            // 带证书号复制
            selectCertnoCopy() {
                var dataCopyStr = ''
                var forlist = this.dataOnLineListSelections
                for(var i=0; i<forlist.length; i++){
                    var dataCopy = forlist[i].shape+','+forlist[i].ct+','+forlist[i].col+','+forlist[i].cla
                                +','+forlist[i].cut+','+forlist[i].pol+','+forlist[i].sym+','+forlist[i].fl
                                +','+forlist[i].new_dis+',¥'+forlist[i].sale_price+','+forlist[i].cert
                                +','+forlist[i].cert_no+';'
                    dataCopyStr = dataCopyStr + '\n' + dataCopy
                }
                // console.log(dataCopyStr)
                // 数据拼接
                // var dataCopy = this.dataOnLineListSelections.map((item) => item.shape+','+item.ct+','+item.col+','+item.cla+','+item.cut+','+item.pol+','+item.sym+','+item.fl+','+item.new_dis+',¥'+item.sale_price+','+item.cert+','+item.cert_no+';\n')
                // console.log(dataCopy)
                // 复制
                this.copyText(dataCopyStr);
            },
            // 不带证书号复制
            selectNoCertnoCopy() {
                var dataCopyStr = ''
                var forlist = this.dataOnLineListSelections
                for(var i=0; i<forlist.length; i++){
                    var dataCopy = forlist[i].shape+','+forlist[i].ct+','+forlist[i].col+','+forlist[i].cla
                                +','+forlist[i].cut+','+forlist[i].pol+','+forlist[i].sym+','+forlist[i].fl
                                +','+forlist[i].new_dis+',¥'+forlist[i].sale_price+','+forlist[i].cert
                                +';'
                    dataCopyStr = dataCopyStr + '\n' + dataCopy
                }
                // console.log(dataCopyStr)
                // 数据拼接
                // var dataCopy = this.dataOnLineListSelections.map((item) => item.shape+','+item.ct+','+item.col+','+item.cla+','+item.cut+','+item.pol+','+item.sym+','+item.fl+','+item.new_dis+',¥'+item.sale_price+','+item.cert+';\n')
                // console.log(dataCopy)
                // 复制
                this.copyText(dataCopyStr);
            },
            // 获取证书号
            selectCertno() {
                this.certnoStr = this.certnoList.join(',');
                this.certnoStr = this.certnoStr.replaceAll(',','');
                // console.log(this.certnoStr)
                // this.dialogTableVisible = true;
                // 复制
                this.copyText(this.certnoStr);
            },
            copyText(val){
                // 存储传递过来的数据
                //let userId = sessionStorage.getItem("userId");
                // createElement() 方法通过指定名称创建一个元素
                let newInput = document.createElement('textarea');
                // 讲存储的数据赋值给input的value值
                newInput.value = val;
                // appendChild() 方法向节点添加最后一个子节点
                document.body.appendChild(newInput);
                // select() 方法用于选择该元素中的文本
                newInput.select();
                // execCommand方法是执行一个对当前文档，当前选择或者给出范围的命令
                document.execCommand('Copy');
                // 清空输入框
                newInput.remove();
                // 下面是element的弹窗 不需要的自行删除就好
                this.$message({
                    message: "复制成功",
                    type: "success",
                });
            },
            // 修改数据状态
            savaDataParams1() {
                let _this = this;
                _this.idStr = _this.idList.join(',');
                // 地点需要校验
                if(_this.dialogTableVisible2){
                    _this.rules2.place[0].required = true;
                    _this.rules2.upload_date[0].required = false;
                }
                // 到货日需要校验
                if(_this.dialogTableVisible5){
                    _this.rules2.place[0].required = false;
                    _this.rules2.upload_date[0].required = true;
                }
                this.$refs.addDataForm2.validate((valid) => {
                    if (valid) { // 通过了则将数据返回后台
                        util.publicget('/diamond/savaDaimondInfoStatus', {
                            // user: document.cookie.split(';')[1].split('=')[1],
                            user: sessionStorage.getItem('userName'),
                            sale_status: _this.addDataForm2.sale_status,
                            place: _this.addDataForm2.place,
                            upload_date: _this.addDataForm2.upload_date,
                            id: _this.idStr
                        }, function (res) {
                            if (res.flag) {
                                // console.log(res);
                                _this.successMsg(res.msg);
                                _this.dialogTableVisible1 = false;
                                _this.dialogTableVisible2 = false;
                                _this.selectDiamondInfoList();
                            } else {
                                _this.errorMsg(res.msg);
                            }
                        })
                    }
                });
            },
            // 预定/释放 生成订单信息
            savaDataParams2() {
                let _this = this;
                _this.idStr = _this.idList.join(',');
                _this.cert_no = _this.certnoList.join(',').replaceAll('\n','');
                _this.sale_priceStr = _this.sale_priceList.join(',');
                // 释放不需要保单校验
                if(_this.addDataForm3.yuliu==='2'){
                    _this.rules3.vipCount[0].required = false;
                    _this.rules3.date_long[0].required = false;
                    _this.rules3.clients[0].required = false;
                }else{
                    _this.rules3.vipCount[0].required = true;
                    _this.rules3.date_long[0].required = true;
                    _this.rules3.clients[0].required = false;
                }
                this.$refs.addDataForm3.validate((valid) => {
                    if (valid) { // 通过了则将数据返回后台
                        util.publicget('/diamond/savaOrderInfo', {
                            // user: document.cookie.split(';')[1].split('=')[1],
                            user: sessionStorage.getItem('userName'),
                            yuliu: _this.addDataForm3.yuliu,
                            vipCount: _this.addDataForm3.vipCount,
                            date_long: _this.addDataForm3.date_long,
                            remark1: _this.addDataForm3.remark1,
                            sale_rate: _this.ratevalue,
                            // sale_back: _this.addDataForm3.sale_back,
                            // tiaoguo: _this.checkboxGroup10 == null ? '' :_this.checkboxGroup10[0],
                            sale_priceStr: _this.sale_priceStr,
                            id: _this.idStr,
                            cert_no: _this.cert_no
                        }, function (res) {
                            if (res.flag) {
                                // console.log(res);
                                _this.successMsg(res.msg);
                                _this.dialogTableVisible3 = false;
                                _this.selectDiamondInfoList();
                            } else {
                                _this.errorMsg(res.msg);
                            }
                        })
                    }
                });
            },
            // 借出/归还 
            savaDataParams3() {
                let _this = this;
                _this.idStr = _this.idList.join(',');
                _this.cert_no = _this.certnoList.join(',').replaceAll('\n','');
                // 归还不需要保单校验
                if(_this.addDataForm4.islend==='2'||_this.addDataForm4.islend==='3'){
                    _this.rules4.vip[0].required = false;
                    _this.rules4.dateline[0].required = false;
                }else {
                    _this.rules4.vip[0].required = true;
                    _this.rules4.dateline[0].required = true;
                }
                this.$refs.addDataForm4.validate((valid) => {
                    if (valid) { // 通过了则将数据返回后台
                        util.publicget('/diamond/lendOrderInfo', {
                            // user: document.cookie.split(';')[1].split('=')[1],
                            user: sessionStorage.getItem('userName'),
                            islend: _this.addDataForm4.islend,
                            sale_rate: _this.ratevalue,
                            // sale_back: _this.addDataForm4.sale_back,
                            vip: _this.addDataForm4.vip,
                            dateline: _this.addDataForm4.dateline,
                            remark: _this.addDataForm4.remark,
                            id: _this.idStr,
                            cert_no: _this.cert_no
                        }, function (res) {
                            if (res.flag) {
                                // console.log(res);
                                _this.successMsg(res.msg);
                                _this.dialogTableVisible4 = false;
                                _this.selectDiamondInfoList();
                            } else {
                                _this.errorMsg(res.msg);
                            }
                        })
                    }
                });
            },
            // 全款借货
            savaDataParams6() {
                let _this = this;
                _this.idStr = _this.idList.join(',');
                _this.cert_no = _this.certnoList.join(',').replaceAll('\n','');
                // 释放不需要保单校验
                if(_this.addDataForm3.islend==='2'){
                    _this.rules3.clients[0].required = false;
                }else{
                    _this.rules3.clients[0].required = true;
                }
                this.$refs.addDataForm3.validate((valid) => {
                    if (valid) { // 通过了则将数据返回后台
                        util.publicget('/diamond/fullLendOrderInfo', {
                            // user: document.cookie.split(';')[1].split('=')[1],
                            user: sessionStorage.getItem('userName'),
                            sale_rate: _this.ratevalue,
                            // sale_back: _this.addDataForm3.sale_back,
                            clients: _this.addDataForm3.clients,
                            islend: _this.addDataForm3.islend,
                            remark2: _this.addDataForm3.remark2,
                            cert_no: _this.cert_no,
                            id: _this.idStr
                        }, function (res) {
                            if (res.flag) {
                                // console.log(res);
                                _this.successMsg(res.msg);
                                _this.dialogTableVisible9 = false;
                                _this.selectDiamondInfoList();
                            } else {
                                _this.errorMsg(res.msg);
                            }
                        })
                    }
                });
            },
            // 一键上架，将进销存数据上架到钻石销售
            savaDataParams31() {
                let _this = this;
                // _this.idStr = _this.idList.join(',');
                _this.cert_no = _this.certnoList.join(',').replaceAll('\n','');
                // _this.sale_priceStr = _this.sale_priceList.join(',');
                util.publicget('/financial/savaJXCinDiamond', {
                    user: document.cookie.split(';')[1].split('=')[1],
                    // yuliu: '2',
                    // sale_priceStr: _this.sale_priceStr,
                    // id: _this.idStr,
                    cert_no: _this.cert_no
                }, function (res) {
                    if (res.flag) {
                        // console.log(res);
                        _this.successMsg(res.msg);
                        _this.dialogTableVisible14 = false;
                        _this.selectDiamondInfoList();
                    } else {
                        _this.errorMsg(res.msg);
                    }
                })
            },
            // 一键上架，将进销存数据上架到HK钻石销售
            savaDataParams32() {
                let _this = this;
                // _this.idStr = _this.idList.join(',');
                _this.cert_no = _this.certnoList.join(',').replaceAll('\n','');
                // _this.sale_priceStr = _this.sale_priceList.join(',');
                util.publicget('/diamondHK/savaJXCinHKDiamond', {
                    user: document.cookie.split(';')[1].split('=')[1],
                    // yuliu: '2',
                    // sale_priceStr: _this.sale_priceStr,
                    // id: _this.idStr,
                    cert_no: _this.cert_no
                }, function (res) {
                    if (res.flag) {
                        // console.log(res);
                        _this.successMsg(res.msg);
                        _this.dialogTableVisible18 = false;
                        _this.selectDiamondInfoList();
                    } else {
                        _this.errorMsg(res.msg);
                    }
                })
            },
            // 一键上架，将进销存数据上架到HK钻石销售
            savaDataParams33() {
                let _this = this;
                // _this.idStr = _this.idList.join(',');
                _this.cert_no = _this.certnoList.join(',').replaceAll('\n','');
                // _this.sale_priceStr = _this.sale_priceList.join(',');
                util.publicget('/diamondHK/savaSZinHKDiamond', {
                    user: document.cookie.split(';')[1].split('=')[1],
                    cert_no: _this.cert_no
                }, function (res) {
                    if (res.flag) {
                        // console.log(res);
                        _this.successMsg(res.msg);
                        _this.dialogTableVisible23 = false;
                        _this.selectDiamondInfoList();
                    } else {
                        _this.errorMsg(res.msg);
                    }
                })
            },
            // 检查rap是否正确
            checkRap1() {
                let _this = this;
                // _this.showMsg('正在更新Rap,请勿重复操作！');
                // _this.idStr = _this.idList.join(',');
                // let cert_no = _this.certnoAll.join(',').replaceAll('\n','');
                util.publicget('/financial/selectRAPInfo', {
                    // user: document.cookie.split(';')[1].split('=')[1],
                    user: sessionStorage.getItem('userName'),
                }, function (res) {
                    if (res.flag) {
                        let hasError = false;
                        _this.dataOnLineListSelections.forEach(item => {
                            let rap = item.sale_rap;

                            let para = item.para;
                            if(para.includes('110') || para.includes('120') || para.includes('130') || para.includes('140')){
                                para = para.replaceAll('110','100');
                                para = para.replaceAll('120','100');
                                para = para.replaceAll('130','100');
                                para = para.replaceAll('140','100');
                            }else if(para.includes('60')){
                                para = para.replaceAll('60','50');
                            }else if(para.includes('80')){
                                para = para.replaceAll('80','70');
                            }
                            let shape = '圆形';
                            if(item.shape != '圆形'){
                                shape = '异形';
                            }else{
                                if(item.cut == 'NN' || item.cut == ''){
                                    shape = '异形';
                                }
                            }
                            
                            let rap_info = res.obj.find(item1 => item1.para === para && item1.rap === rap && item1.shape === shape);
                            let rap_info_right = res.obj.find(item1 => item1.para === para);
                            if(!rap_info){
                                _this.errorMsg('证书号：'+item.cert_no+' 的RAP有误！正确RAP是: ' + (rap_info_right ? rap_info_right.rap : '未找到') + ' ');
                                hasError = true;
                                return;
                            }
                        });
                        if(!hasError){
                            _this.successMsg('检查完成,Rap没有问题！');
                        }
                        // console.log(res);
                        //_this.successMsg(res.msg);
                    } else {
                        _this.errorMsg(res.msg);
                    }
                })
            },
            // 检查rap是否正确
            checkRap() {
                let _this = this;
                util.publicget('/financial/selectRAPInfo', {
                    user: sessionStorage.getItem('userName'),
                }, function (res) {
                    if (res.flag) {
                        let hasError = false;
                        
                        // 优化1: 创建Map索引，避免重复查找
                        const rapInfoMap = new Map();
                        const rapInfoByParaMap = new Map();
                        
                        res.obj.forEach(rapInfo => {
                            // 创建复合键用于快速查找
                            const key = `${rapInfo.para}_${rapInfo.rap}_${rapInfo.shape}`;
                            rapInfoMap.set(key, rapInfo);
                            
                            // 按para分组，用于错误提示
                            if (!rapInfoByParaMap.has(rapInfo.para)) {
                                rapInfoByParaMap.set(rapInfo.para, rapInfo);
                            }
                        });
                        
                        // 优化2: 预处理para替换规则
                        const paraReplaceRules = [
                            { from: ['110', '120', '130', '140'], to: '100' },
                            { from: ['60'], to: '50' },
                            { from: ['80'], to: '70' }
                        ];
                        
                        // 优化3: 批量处理，减少循环次数
                        for (let i = 0; i < _this.dataOnLineListSelections.length; i++) {
                            const item = _this.dataOnLineListSelections[i];
                            const rap = item.sale_rap;
                            
                            // 优化4: 使用更高效的字符串替换
                            let para = item.para;
                            for (const rule of paraReplaceRules) {
                                for (const from of rule.from) {
                                    if (para.includes(from)) {
                                        para = para.replaceAll(from, rule.to);
                                    }
                                }
                            }
                            
                            // 优化5: 简化shape判断逻辑
                            //const shape = (item.shape !== '圆形' || item.cut === 'NN' || item.cut === '') 
                            //    ? '异形' : '圆形';
                            
                            let shape = '圆形';
                            if(item.shape != '圆形'){
                                shape = '异形';
                            }else{
                                if(item.cut == 'NN' || item.cut == ''){
                                    shape = '异形';
                                }
                            }

                            // 优化6: 使用Map进行O(1)查找
                            const key = `${para}_${rap}_${shape}`;
                            const rapInfo = rapInfoMap.get(key);
                            
                            if (!rapInfo) {
                                const rapInfoRight = rapInfoByParaMap.get(para);
                                _this.errorMsg('证书号：' + item.cert_no + ' 的RAP有误！正确RAP是: ' + 
                                    (rapInfoRight ? rapInfoRight.rap : '未找到') + ' ');
                                hasError = true;
                                break; // 优化7: 早期退出，避免不必要的处理
                            }
                        }
                        
                        if (!hasError) {
                            _this.successMsg('检查完成,Rap没有问题！');
                        }
                    } else {
                        _this.errorMsg(res.msg);
                    }
                })
            },
            // 批量更新rap
            savaDataParams8() {
                let _this = this;
                // _this.showMsg('正在更新Rap,请勿重复操作！');
                // _this.idStr = _this.idList.join(',');
                let cert_no = _this.certnoList.join(',').replaceAll('\n','');
                // _this.cert_no = _this.certnoList.join(',').replaceAll('\n','');
                // _this.sale_priceStr = _this.sale_priceList.join(',');
                _this.dialogTableVisible15 = false;
                _this.dialogTableVisible17 = false;
                util.publicget('/financial/savaRapInfo', {
                    // user: document.cookie.split(';')[1].split('=')[1],
                    user: sessionStorage.getItem('userName'),
                    cert_no: cert_no
                }, function (res) {
                    if (res.flag) {
                        // console.log(res);
                        _this.successMsg(res.msg);
                        _this.selectDiamondInfoList();
                    } else {
                        _this.errorMsg(res.msg);
                    }
                })
            },
            // 批量更新香港rap
            savaDataParams9() {
                let _this = this;
                // _this.showMsg('正在更新Rap,请勿重复操作！');
                // _this.idStr = _this.idList.join(',');
                // let cert_no = _this.certnoAll.join(',').replaceAll('\n','');
                // _this.cert_no = _this.certnoList.join(',').replaceAll('\n','');
                // _this.sale_priceStr = _this.sale_priceList.join(',');
                _this.dialogTableVisible21 = false;
                _this.dialogTableVisible17 = false;
                util.publicget('/financial/savaHKRapInfo', {
                    // user: document.cookie.split(';')[1].split('=')[1],
                    user: sessionStorage.getItem('userName'),
                    //cert_no: cert_no
                }, function (res) {
                    if (res.flag) {
                        // console.log(res);
                        _this.successMsg(res.msg);
                        _this.selectDiamondInfoList();
                    } else {
                        _this.errorMsg(res.msg);
                    }
                })
            },
            // 调点
            savaDataParams4() {
                let _this = this;
                _this.idStr = _this.idList.join(',');
                this.$refs.addDataForm5.validate((valid) => {
                    if (valid) { // 通过了则将数据返回后台
                        util.publicget('/diamond/adjustDisInfo', {
                            // user: document.cookie.split(';')[1].split('=')[1],
                            user: sessionStorage.getItem('userName'),
                            tiaodian1: _this.addDataForm5.tiaodian1,
                            new_dis: _this.addDataForm5.new_dis,
                            id: _this.idStr
                        }, function (res) {
                            if (res.flag) {
                                // console.log(res);
                                _this.successMsg(res.msg);
                                _this.dialogTableVisible6 = false;
                                _this.selectDiamondInfoList();
                            } else {
                                _this.errorMsg(res.msg);
                            }
                        })
                    }
                });
            },
            // 调整汇率
            savaDataParams7() {
                let _this = this;
                _this.idStr = _this.idList.join(',');
                this.$refs.addDataForm6.validate((valid) => {
                    if (valid) { // 通过了则将数据返回后台
                        util.publicget('/diamond/setRateInfo', {
                            // user: document.cookie.split(';')[1].split('=')[1],
                            user: sessionStorage.getItem('userName'),
                            rate: _this.addDataForm6.rate,
                            id: _this.idStr
                        }, function (res) {
                            if (res.flag) {
                                // console.log(res);
                                _this.successMsg(res.msg);
                                _this.dialogTableVisible11 = false;
                                _this.selectDiamondInfoList();
                            } else {
                                _this.errorMsg(res.msg);
                            }
                        })
                    }
                });
            },
            // 批量修改库存状态
            savaDataParams12() {
                let _this = this;
                _this.idStr = _this.idList.join(',');
                util.publicget('/diamond/savaDaimondInfoStatus', {
                    // user: document.cookie.split(';')[1].split('=')[1],
                    user: sessionStorage.getItem('userName'),
                    inv_status: _this.addDataForm2.inv_status,
                    id: _this.idStr
                }, function (res) {
                    if (res.flag) {
                        // console.log(res);
                        _this.successMsg(res.msg);
                        _this.dialogTableVisible12 = false;
                        _this.selectDiamondInfoList();
                    } else {
                        _this.errorMsg(res.msg);
                    }
                })
            },
            // 删除数据
            savaDataParams5() {
                let _this = this;
                _this.idStr = _this.idList.join(',');
                util.publicget('/financial/deleteProcurementInfo', {
                    // user: document.cookie.split(';')[1].split('=')[1],
                    user: sessionStorage.getItem('userName'),
                    id: _this.idStr
                }, function (res) {
                    if (res.flag) {
                        // console.log(res);
                        _this.successMsg(res.msg);
                        _this.dialogTableVisible8 = false;
                        _this.selectDiamondInfoList();
                    } else {
                        _this.errorMsg(res.msg);
                        _this.dialogTableVisible8 = false;
                    }
                });
            },
            // 修改数据
            savaDataParams() {
                let _this = this;
                // 判断表单是否通过了表单验证
                this.$refs.addDataForm.validate((valid) => {
                    if (valid) { // 通过了则将数据返回后台
                        util.publicget('/financial/savaProcureInfo', {
                            // user: document.cookie.split(';')[1].split('=')[1],
                            user: sessionStorage.getItem('userName'),
                            id: _this.addDataForm.id,
                            place: _this.addDataForm.place,
                            supplier_rapid: _this.addDataForm.supplier_rapid,
                            supplier: _this.addDataForm.supplier,

                            shape: _this.addDataForm.shape,
                            ct: _this.addDataForm.ct,
                            col: _this.addDataForm.col,
                            cla: _this.addDataForm.cla,
                            cut: _this.addDataForm.cut,
                            pol: _this.addDataForm.pol,
                            sym: _this.addDataForm.sym,
                            fl: _this.addDataForm.fl,
                            
                            inv_status: _this.addDataForm.inv_status,
                            sale_status: _this.addDataForm.sale_status,
                            buy_date: _this.addDataForm.buy_date,
                            cost_rap: _this.addDataForm.cost_rap,
                            cost_dis: _this.addDataForm.cost_dis,

                            new_dis: _this.addDataForm.new_dis,
                            sale_rap: _this.addDataForm.sale_rap,
                            cost: _this.addDataForm.cost,
                            point: _this.addDataForm.point,
                            usd_cost: _this.addDataForm.usd_cost,
                            rmb_cost: _this.addDataForm.rmb_cost,
                            meas: _this.addDataForm.meas,

                            table1: _this.addDataForm.table1 ,
                            depth: _this.addDataForm.depth,
                            ratio: _this.addDataForm.ratio,
                            cla_level: _this.addDataForm.cla_level,
                            remark: _this.addDataForm.remark,
                            year: _this.addDataForm.year,
                            rating: _this.addDataForm.rating,
                            deal_date: _this.addDataForm.deal_date,
                            
                            cert: _this.addDataForm.cert,
                            cert_no: _this.addDataForm.cert_no
                        }, function (res) {
                            if (res.flag) {
                                _this.dialogTableVisible10 = false;
                                _this.successMsg('本次操作成功！');
                                _this.selectDiamondInfoList();
                            } else {
                                _this.errorMsg(res.msg);
                            }
                        });
                    } else { // 否则返回
                        return false;
                    }
                });
            },
            // 修改数据 调价
            savaDataParams_tiaojia() {
                let _this = this;
                // 判断表单是否通过了表单验证
                this.$refs.addDataForm.validate((valid) => {
                    if (valid) { // 通过了则将数据返回后台
                        util.publicget('/diamond/savaDaimondInfoTiaojiao', {
                            // user: document.cookie.split(';')[1].split('=')[1],
                            user: sessionStorage.getItem('userName'),
                            id: _this.addDataForm.id,

                            shape: _this.addDataForm.shape,
                            ct: _this.addDataForm.ct,
                            col: _this.addDataForm.col,
                            cla: _this.addDataForm.cla,
                            cut: _this.addDataForm.cut,
                            pol: _this.addDataForm.pol,
                            sym: _this.addDataForm.sym,
                            fl: _this.addDataForm.fl,
                            
                            inv_status: _this.addDataForm.inv_status,
                            sale_status: _this.addDataForm.sale_status,

                            new_dis: _this.addDataForm.new_dis,
                            sale_rap: _this.addDataForm.sale_rap,
                            remark: _this.addDataForm.remark,

                            cert: _this.addDataForm.cert,
                            cert_no: _this.addDataForm.cert_no
                        }, function (res) {
                            if (res.flag) {
                                _this.dialogTableVisible20 = false;
                                _this.successMsg('本次操作成功！');
                                _this.selectDiamondInfoList();
                            } else {
                                _this.errorMsg(res.msg);
                            }
                        });
                    } else { // 否则返回
                        return false;
                    }
                });
            },
            // 更新参数
            savaDataParams13() {
                let _this = this;
                let strArr = _this.addDataForm.remark.split('\n');
                //console.log(strArr)
                let cert_noStr = '';
                for(let k=1;k<strArr.length-1;k++){
                    let certArr = strArr[k].split('\t');
                    // console.log(certArr)
                    // console.log(certArr[0]);
                    let isflag = this.diamondInfoListAll.find(item=>(item.cert_no.trim()) == (certArr[0].trim()));
                    // console.log(isflag)
                    if(isflag === undefined){
                        _this.errorMsg('证书号：'+certArr[0]+' 不存在！');
                        return;
                    }else{
                        cert_noStr += certArr[0] + ',';
                    }
                }
                // 判断表单是否通过了表单验证
                this.$refs.addDataForm2.validate((valid) => {
                    if (valid) { // 通过了则将数据返回后台
                        util.publicget('/financial/savaDaimondInfoAll', {
                            // user: document.cookie.split(';')[1].split('=')[1],
                            user: sessionStorage.getItem('userName'),
                            remark: _this.addDataForm.remark,
                            cert_noStr: cert_noStr
                        }, function (res) {
                            if (res.flag) {
                                _this.successMsg('本次操作成功！');
                                _this.dialogTableVisible13 = false;
                                _this.selectDiamondInfoList();
                            } else {
                                _this.errorMsg(res.msg);
                            }
                        });
                    } else { // 否则返回
                        return false;
                    }
                });
            },
            // dialog 关闭，数据清空
            closeSava() {
                this.addDataForm = {};
                this.addDataForm3 = {};
                this.addDataForm4 = {};
                this.isdisabled=false;
                this.dialogTableVisible10=false;
                this.dialogTableVisible20=false;
                //this.selectDiamondInfoList();
                //this.selectRateDictList();
                this.fileList = [];
            },
            // 前端处理 选中数据导出
            exportSelect() {
                //let res =[{name:'小白',age:'18'},{name:'小黑',age:'16'}]
                require.ensure([], () => {
                    const { export_json_to_excel } = require('../../common/js/Export2Excel.js')
                    const tHeader = ['id','货号','证书号','库存状态','销售状态',
                            '采购时间','入库日期','下单时间','出库时间',
                            '地点','供应商RAPID','供应商','分数段',
                            '形状','重量','颜色','净度','切工',
                            '抛光','对称','荧光','证书','成本rap',
                            '成本折扣','货品成本','综合费点','美金成本','人民币成本',
                            '成本汇率','尺寸','台面','全深','比例',
                            '销售rap','销售折扣','销售美金','销售汇率',
                            '售价','实收rmb','利润','客户','备注',
                            '净度等级','付款日期','证书日期',
                            '评价','货型','年份','新旧折扣差值','应收利润率',
                            'bt','bs','wt','ws','clt','cs','ec','milk','br','gr']
                    const filterVal = ['id','stock_id','cert_no','inv_status','sale_status',
                            'buy_date','storage_date','order_date','deal_date',
                            'place','supplier_rapid','supplier','carat_range',
                            'shape','ct','col','cla','cut',
                            'pol','sym','fl','cert','cost_rap',
                            'cost_dis','cost','point','usd_cost','rmb_cost',
                            'cost_rate','meas','table1','depth','ratio',
                            'sale_rap','new_dis','sale_usd','sale_rate',
                            'sale_price','received_rmb','income','clients','remark',
                            'cla_level','pay_date','cert_date',
                            'rating','para','year','dis_diff','profit_rate',
                            'bt','bs','wt','ws','clt','cs','ec','milk','br','gr' ]
                    const list = this.dataOnLineListSelections
                    list.forEach(item =>{
                        this.$set(item,'sale_usd',Number(Math.round(item.sale_usd)))
                        this.$set(item,'sale_price',Number(Math.round(item.sale_price)))
                        this.$set(item,'ct',Number(item.ct))
                    })
                    const data = this.formatJson(filterVal, list)
                    export_json_to_excel(tHeader, data, '钻石信息')
                })
            },
            formatJson(filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => v[j]))
            },
            exportAll() {
                //let res =[{name:'小白',age:'18'},{name:'小黑',age:'16'}]
                require.ensure([], () => {
                    const { export_json_to_excel } = require('../../common/js/Export2Excel.js')
                    const tHeader = ['id','货号','证书号','库存状态','销售状态',
                            '采购时间','入库日期','下单时间','出库时间',
                            '地点','供应商RAPID','供应商','分数段',
                            '形状','重量','颜色','净度','切工',
                            '抛光','对称','荧光','证书','成本rap',
                            '成本折扣','货品成本','综合费点','美金成本','人民币成本',
                            '成本汇率','尺寸','台面','全深','比例',
                            '销售rap','销售折扣','销售美金','销售汇率',
                            '售价','实收rmb','利润','客户','备注',
                            '净度等级','付款日期','证书日期',
                            '评价','货型','年份','新旧折扣差值','应收利润率',
                            'bt','bs','wt','ws','clt','cs','ec','milk','br','gr']
                    const filterVal = ['id','stock_id','cert_no','inv_status','sale_status',
                            'buy_date','storage_date','order_date','deal_date',
                            'place','supplier_rapid','supplier','carat_range',
                            'shape','ct','col','cla','cut',
                            'pol','sym','fl','cert','cost_rap',
                            'cost_dis','cost','point','usd_cost','rmb_cost',
                            'cost_rate','meas','table1','depth','ratio',
                            'sale_rap','new_dis','sale_usd','sale_rate',
                            'sale_price','received_rmb','income','clients','remark',
                            'cla_level','pay_date','cert_date',
                            'rating','para','year','dis_diff','profit_rate',
                            'bt','bs','wt','ws','clt','cs','ec','milk','br','gr' ]
                    const list = this.diamondAllInfoList
                    const data = this.formatJson(filterVal, list)
                    export_json_to_excel(tHeader, data, '全部钻石信息')
                })
            },
            // 查询全部数据用于导出
            selectAllList() {
                let _this = this;
                util.publicget('/financial/queryProcureListByCondition', {
                }, function (res) {
                    if (res.flag) {
                        //console.log(res.obj);
                        if(res.obj.length>0) {
                            _this.diamondAllInfoList = res.obj;
                            _this.exportAll();
                        }else {
                            _this.errorMsg("导出失败！");
                        }
                    } else {
                        _this.errorMsg("导出失败！");
                    }
                });
            },
            // 导出选中数据为CSV
            exportSelectCSV() {
                require.ensure([], () => {
                    const { export_json_to_csv } = require('../../common/js/Export2Excel.js')
                    const tHeader = ['id','货号','证书号','库存状态','销售状态',
                            '采购时间','入库日期','下单时间','出库时间',
                            '地点','供应商RAPID','供应商','分数段',
                            '形状','重量','颜色','净度','切工',
                            '抛光','对称','荧光','证书','成本rap',
                            '成本折扣','货品成本','综合费点','美金成本','人民币成本',
                            '成本汇率','尺寸','台面','全深','比例',
                            '销售rap','销售折扣','销售美金','销售汇率',
                            '售价','实收rmb','利润','客户','备注',
                            '净度等级','付款日期','证书日期',
                            '评价','货型','年份','新旧折扣差值','应收利润率',
                            'bt','bs','wt','ws','clt','cs','ec','milk','br','gr']
                    const filterVal = ['id','stock_id','cert_no','inv_status','sale_status',
                            'buy_date','storage_date','order_date','deal_date',
                            'place','supplier_rapid','supplier','carat_range',
                            'shape','ct','col','cla','cut',
                            'pol','sym','fl','cert','cost_rap',
                            'cost_dis','cost','point','usd_cost','rmb_cost',
                            'cost_rate','meas','table1','depth','ratio',
                            'sale_rap','new_dis','sale_usd','sale_rate',
                            'sale_price','received_rmb','income','clients','remark',
                            'cla_level','pay_date','cert_date',
                            'rating','para','year','dis_diff','profit_rate',
                            'bt','bs','wt','ws','clt','cs','ec','milk','br','gr' ]
                    const list = this.dataOnLineListSelections
                    const data = this.formatJson(filterVal, list)
                    export_json_to_csv(tHeader, data, '钻石信息')
                })
            },

            // 导出全部数据为CSV
            exportAllCSV() {
                require.ensure([], () => {
                    // const { export_json_to_csv } = require('../../common/js/Export2Excel.js')
                    const { export_large_json_to_csv } = require('../../common/js/Export2Excel.js')
                    const tHeader = ['id','货号','证书号','库存状态','销售状态',
                            '采购时间','入库日期','下单时间','出库时间',
                            '地点','供应商RAPID','供应商','分数段',
                            '形状','重量','颜色','净度','切工',
                            '抛光','对称','荧光','证书','成本rap',
                            '成本折扣','货品成本','综合费点','美金成本','人民币成本',
                            '成本汇率','尺寸','台面','全深','比例',
                            '销售rap','销售折扣','销售美金','销售汇率',
                            '售价','实收rmb','利润','客户','备注',
                            '净度等级','付款日期','证书日期',
                            '评价','货型','年份','新旧折扣差值','应收利润率',
                            'bt','bs','wt','ws','clt','cs','ec','milk','br','gr']
                    const filterVal = ['id','stock_id','cert_no','inv_status','sale_status',
                            'buy_date','storage_date','order_date','deal_date',
                            'place','supplier_rapid','supplier','carat_range',
                            'shape','ct','col','cla','cut',
                            'pol','sym','fl','cert','cost_rap',
                            'cost_dis','cost','point','usd_cost','rmb_cost',
                            'cost_rate','meas','table1','depth','ratio',
                            'sale_rap','new_dis','sale_usd','sale_rate',
                            'sale_price','received_rmb','income','clients','remark',
                            'cla_level','pay_date','cert_date',
                            'rating','para','year','dis_diff','profit_rate',
                            'bt','bs','wt','ws','clt','cs','ec','milk','br','gr' ]
                    const list = this.diamondAllInfoList
                    const data = this.formatJson(filterVal, list)
                    // export_json_to_csv(tHeader, data, '全部钻石信息')
                    export_large_json_to_csv(tHeader, data, '全部钻石信息', 1000)
                })
            },

            // 查询全部数据用于CSV导出
            selectAllListCSV() {
                let _this = this;
                util.publicget('/financial/queryProcureListByCondition', {
                }, function (res) {
                    if (res.flag) {
                        //console.log(res.obj);
                        if(res.obj.length>0) {
                            _this.diamondAllInfoList = res.obj;
                            _this.exportAllCSV();
                        }else {
                            _this.errorMsg("导出失败！");
                        }
                    } else {
                        _this.errorMsg("导出失败！");
                    }
                });
            },
            // 展开行查询数据处理
            expandChange(row,expandedRows){
                let _this = this;
                util.publicget('/diamond/queryDaimondLog', {
                    equalsCert_no: row.cert_no
                }, function (res) {
                    if (res.flag) {
                        _this.diamondLog = res.obj;
                    }else {
                        console.log("查询失败！");
                    }
                });
                _this.$set(item, 'diamondLog', _this.diamondLog);
            },
            // 加载分页数据信息
            selectDiamondInfoList() {
                let _this = this;
                util.publicget('/financial/queryProcureListPageModel', {
                    shape: _this.query.shape,
                    col: _this.query.col,
                    cla: _this.query.cla,
                    cut: _this.query.cut,
                    pol: _this.query.pol,
                    sym: _this.query.sym,
                    fl: _this.query.fl,
                    place: _this.query.place,
                    cert: _this.query.cert,
                    cert_no: _this.query.cert_no,
                    stock_id: _this.query.stock_id,
                    sale_status: _this.query.sale_status,
                    inv_status: _this.query.inv_status,
                    greaterEqualsCt: _this.query.ct1,
                    lessEqualsCt: _this.query.ct2,
                    greaterEqualsMax_meas: _this.query.max_meas1,
                    lessEqualsMax_meas: _this.query.max_meas2,
                    greaterEqualsMin_meas: _this.query.min_meas1,
                    lessEqualsMin_meas: _this.query.min_meas2,
                    supplier: _this.query.supplier,
                    remark: _this.query.remark,
                    pageNo: _this.pager.page,
                    pageSize: _this.pager.rows,
                    order: _this.order,
                    greaterEqualsBuy_date: _this.query.buy_date == null ? '' : _this.query.buy_date[0],
                    lessEqualsBuy_date: _this.query.buy_date == null ? '' : _this.query.buy_date[1],
                    greaterEqualsDeal_date: _this.query.deal_date == null ? '' : _this.query.deal_date[0],
                    lessEqualsDeal_date: _this.query.deal_date == null ? '' : _this.query.deal_date[1],
                    column: _this.column
                }, function (res) {
                    if (res.flag) {
                        // console.log(res);
                        _this.pager.total = res.count || 0;
                        if(res.count < _this.pager.rows){
                            _this.pager.page = 1;
                        }
                        _this.diamondInfoList = res.obj;
                        _this.certnoList = res.obj.map((item) => item.cert_no + '\n');
                        _this.idList = res.obj.map((item) => item.id);
                    } else {
                        _this.errorMsg('本次操作失败');
                    }
                });
            },
            // 加载查询单条记录
            selectList(rows) {
                let _this = this;
                util.publicget('/financial/queryProcureListByCondition', {
                    equalsId: rows.id,
                    equalsCert_no: rows.cert_no
                }, function (res) {
                    if (res.flag) {
                        //console.log(res.obj);
                        if(res.obj.length>0) {
                            _this.addDataForm = res.obj[0];
                            _this.dialogTableVisible10 = true;
                        }else {
                            _this.showMsg("该证书号数据不存在");
                        }
                    } else {
                        _this.errorMsg(res.msg);
                    }
                });
            },
            // 加载查询单条记录 用于调价
            selectList2(rows) {
                let _this = this;
                util.publicget('/diamond/queryDaimondList', {
                    equalsId: rows.id,
                    equalsCert_no: rows.cert_no
                }, function (res) {
                    if (res.flag) {
                        //console.log(res.obj);
                        if(res.obj.length>0) {
                            _this.addDataForm = res.obj[0];
                            _this.dialogTableVisible20 = true;
                        }else {
                            _this.showMsg("该证书号数据不存在");
                        }
                    } else {
                        _this.errorMsg(res.msg);
                    }
                });
            },
            // 查询数据字典 地点
            selectPlaceDictList() {
                let _this = this;
                util.publicget('/diamond/queryDaimondDictList', {
                    equalsParam: '地点'
                }, function (res) {
                    if (res.flag) {
                        //console.log(res.obj);
                        _this.placeList = res.obj;
                    } else {
                        _this.errorMsg("操作异常！");
                    }
                });
            },
            // 查询数据字典 汇率
            selectRateDictList() {
                let _this = this;
                util.publicget('/diamond/queryDaimondDictList', {
                    equalsParam: '汇率'
                }, function (res) {
                    if (res.flag) {
                        //console.log(res.obj);
                        _this.ratevalue = res.obj[0].value;
                    } else {
                        _this.errorMsg("操作异常！");
                    }
                });
            },
            // 导出查钻文件 当日调价数据
            exportExcelCZTJFileTemplate() {
                let _this = this;
                _this.cert_no = _this.certnoList.join(',').replaceAll('\n','');
                util.publicget('/diamond/queryCZTiaojiaDaimondList', {
                    cert_no: _this.cert_no
                }, function (res) {
                    if (res.flag) {
                        //console.log(res.obj);
                        if(res.obj.length>0) {
                            _this.diamondCZInfoList = res.obj;
                            _this.exportCZAll();
                        }else {
                            _this.errorMsg("导出失败！");
                        }
                    } else {
                        _this.errorMsg("导出失败！");
                    }
                });
            },
            // 导出查钻文件
            exportExcelCZFileTemplate() {
                let _this = this;
                util.publicget('/diamond/queryCZDaimondList', {
                }, function (res) {
                    if (res.flag) {
                        //console.log(res.obj);
                        if(res.obj.length>0) {
                            _this.diamondCZInfoList = res.obj;
                            _this.exportCZAll();
                        }else {
                            _this.errorMsg("导出失败！");
                        }
                    } else {
                        _this.errorMsg("导出失败！");
                    }
                });
            },
            // 导出查钻数据
            exportCZAll() {
                //let res =[{name:'小白',age:'18'},{name:'小黑',age:'16'}]
                require.ensure([], () => {
                    const { export_json_to_excel } = require('../../common/js/Export2Excel.js')
                    const tHeader = ['stoneid','shape','carat','color','clarity'
                                ,'cut','polish','symmetry','fluorescence','milky'
                                ,'colsh','rmb','report','reportno','disount'
                                ,'address','measurement','rap','备注','状态'
                                ,'black','table','depth','eyeClean','BT'
                                ,'BC','WT','WC','是否报关','country'
                                ,'是否特价','预留字段','买汇率','买人民币','图片链接'
                                ,'视频链接','溯源码','海关核准单号','买折扣']
                    const filterVal = ['id','shape','ct','col','cla'
                                ,'cut','pol','sym','fl','milky'
                                ,'colsh','sale_price','cert','cert_no','new_dis'
                                ,'place','meas','sale_rap','remark','inv_status'
                                ,'black','table1','depth','eyeClean','BT'
                                ,'BC','WT','WC','是否报关','country'
                                ,'isdis','预留字段','买汇率','买人民币','图片链接'
                                ,'视频链接','溯源码','海关核准单号','买折扣']
                    const list = this.diamondCZInfoList
                    list.forEach(item =>{
                        this.$set(item,'isdis','是')
                        this.$set(item,'country','CHINA')
                        this.$set(item,'milky','无奶')
                        this.$set(item,'colsh','无咖')
                        this.$set(item,'remark','')
                        this.$set(item,'inv_status','在库')
                        this.$set(item,'eyeClean','EC0')
                        this.$set(item,'BT','BT0')
                        this.$set(item,'BC','BC0')
                        this.$set(item,'WT','WT0')
                        this.$set(item,'WC','WC0')
                        this.$set(item,'是否报关','')
                    })
                    const data = this.formatJson(filterVal, list)
                    export_json_to_excel(tHeader, data, '查钻上传数据')
                })
            },
            // 导出文件 ,可以根据前端选择不同的类型进行不同文件导出
            exportRapnetFileOne() {
                let _this = this;
                util.publicget('/diamond/exportRapnetFileOne', {
                    // user: document.cookie.split(';')[1].split('=')[1],
                    user: sessionStorage.getItem('userName')
                }, function (res) {
                    if (res.flag) {
                        // console.log(res);
                        //window.location.href = "/usr/local/nginx/html/dist/static/"+res.file_path;
                        window.location.href = "/static/data/"+res.file_path;
                        //const a = document.createElement('a');
                        //a.href = 'RapnetData.csv';
                        //a.setAttribute('download','RapnetData.csv')
                        //a.download = 'RapnetData.csv';
                        //a.style.display = 'none';
                        //a.click();
                        //window.open('/static/RapnetData.csv');
                        //this.$download("/usr/local/nginx/html/dist/static/data/",res.file_path)
                        //_this.successMsg(res.msg);
                    } else {
                        _this.errorMsg(res.msg);
                    }
                });
            },
            // 导出rapnet文件
            exportExcelRapnetFileTemplate() {
                let _this = this;
                util.publicget('/diamond/queryCZDaimondList', {
                }, function (res) {
                    if (res.flag) {
                        //console.log(res.obj);
                        if(res.obj.length>0) {
                            _this.diamondRapnetInfoList = res.obj;
                            _this.exportRapnetAll();
                        }else {
                            _this.errorMsg("导出失败！");
                        }
                    } else {
                        _this.errorMsg("导出失败！");
                    }
                });
            },
            // 导出rapnet数据
            exportRapnetAll() {
                //let res =[{name:'小白',age:'18'},{name:'小黑',age:'16'}]
                require.ensure([], () => {
                    const { export_json_to_excel } = require('../../common/js/Export2Excel.js')
                    const tHeader = ['Stock #','Availability','Shape','Weight','Color'
                        ,'Clarity','Cut Grade','Polish','Symmetry','Fluorescence Intensity'
                        ,'Fluorescence Color','Measurements','BGM','Eye Clean'
                        ,'Lab','Report #','RapLab Report ID','Treatment','RapNet Price'
                        ,'RapNet  Discount %','Cash Price','Cash Price Discount %','Depth %','Table %'
                        ,'Girdle Thin','Girdle Thick','Girdle %','Girdle Condition','Culet Size'
                        ,'Culet Condition','Crown Height','Crown Angle','Pavilion Depth','Pavilion Angle'
                        ,'Laser Inscription','Cert comment','Key to symbols','Member Comment','Star Length'
                        ,'Shade','White Inclusion','Black Inclusion','Open Inclusion','Milky'
                        ,'Fancy Color','Fancy Color Intensity','Fancy Color Overtone','Country','State'
                        ,'City','Brand','Seller Spec','Report Filename','Diamond Image'
                        ,'Video Link','Sarine Loupe','Trade Show','Report Issue Date','Report Type'
                        ,'Lab Location','Pair Stock #','Is Matched Pair Separable','Allow RapLink Feed','Parcel Stones']
                    const filterVal = ['id','Availability','shape','ct','col'
                        ,'cla','cut','pol','sym','fl'
                        ,'Fluorescence Color','meas','BGM','Eye Clean'
                        ,'Lab','cert_no','RapLab Report ID','Treatment','sale_usd'
                        ,'RapNet  Discount %','Cash Price','Cash Price Discount %','depth','table1'
                        ,'Girdle Thin','Girdle Thick','Girdle %','Girdle Condition','Culet Size'
                        ,'Culet Condition','Crown Height','Crown Angle','Pavilion Depth','Pavilion Angle'
                        ,'Laser Inscription','Cert comment','Key to symbols','Member Comment','Star Length'
                        ,'Shade','White Inclusion','Black Inclusion','Open Inclusion','Milky'
                        ,'Fancy Color','Fancy Color Intensity','Fancy Color Overtone','Country','State'
                        ,'City','Brand','Seller Spec','Report Filename','Diamond Image'
                        ,'Video Link','Sarine Loupe','Trade Show','Report Issue Date','Report Type'
                        ,'Lab Location','Pair Stock #','Is Matched Pair Separable','Allow RapLink Feed','Parcel Stones']
                    const list = this.diamondRapnetInfoList
                    list.forEach(item =>{
                        this.$set(item,'Availability','G')
                        this.$set(item,'BGM','no')
                        this.$set(item,'Eye Clean','yes')
                        this.$set(item,'Lab','GIA')
                        this.$set(item,'Laser Inscription','yes')
                        this.$set(item,'Member Comment','stone in SZ  wechat:18565895222 Skype:live:.cid.bab6686d2460340c  contact:18565895222')
                        this.$set(item,'Country','CHINA')
                        if(item.shape === '圆形'){
                            this.$set(item,'shape','round')
                        }else if(item.shape === '公主方') {
                            this.$set(item,'shape','princess')
                        }else if(item.shape === '雷迪恩') {
                            this.$set(item,'shape','radiant')
                        }else if(item.shape === '阿斯切') {
                            this.$set(item,'shape','asscher')
                        }else if(item.shape === '马眼形' || item.shape === '马眼') {
                            this.$set(item,'shape','marquise')
                        }else if(item.shape === '椭圆' || item.shape === '椭圆形') {
                            this.$set(item,'shape','oval')
                        }else if(item.shape === '祖母绿') {
                            this.$set(item,'shape','emerald')
                        }else if(item.shape === '梨形') {
                            this.$set(item,'shape','pear')
                        }else if(item.shape === '心形') {
                            this.$set(item,'shape','heart')
                        }else if(item.shape === '垫形') {
                            this.$set(item,'shape','cushion')
                        }else if(item.shape === '其他') {
                            this.$set(item,'shape','others')
                        }else if(item.shape === '三角形') {
                            this.$set(item,'shape','triangle')
                        }
                    })
                    //console.log(list)
                    const data = this.formatJson(filterVal, list)
                    export_json_to_excel(tHeader, data, 'rapnet上传数据')
                })
            },
            // 导出文件 ,可以根据前端选择不同的类型进行不同文件导出
            exportExcelRapnetFileTemplate1() {
                let _this = this;
                util.publicget('/diamond/exportExcelRapnetFileTemplate', {
                    // user: document.cookie.split(';')[1].split('=')[1],
                    user: sessionStorage.getItem('userName')
                }, function (res) {
                    if (res.flag) {
                        // console.log(res);
                        window.location.href = "/download/data/"+res.file_path;
                        _this.successMsg(res.msg);
                    } else {
                        _this.errorMsg(res.msg);
                    }
                });
            },
            // 上传rapnet
            uploadRapnetFile() {
                let _this = this;
                _this.successMsg('正在上传Rapnet,请勿重复操作！');
                util.publicget('/diamond/uploadRapnetFile', {
                    // user: document.cookie.split(';')[1].split('=')[1],
                    user: sessionStorage.getItem('userName')
                }, function (res) {
                    if (res.flag) {
                        // console.log(res);
                        //window.location.href = "/download/data/"+res.file_path;
                        _this.successMsg('操作成功！');
                    } else {
                        _this.errorMsg('操作失败！');
                    }
                });
            },
            // 查询全进销存证书号信息
            selectListAll() {
                let _this = this;
                util.publicget('/financial/queryProcureCertNoList', {
                }, function (res) {
                    if (res.flag) {
                        // console.log(res.obj);
                        _this.diamondInfoListAll = res.obj;
                        _this.isUPAble = false;
                        _this.certnoAll = res.obj.map((item) => item.cert_no + '\n');
                        //_this.$nextTick(()=> {
                        //    _this.isUPAble = false;
                        //})
                    } else {
                        _this.errorMsg(res.msg);
                    }
                });
            },
            // 取消
            resetForm(formName) {
                this.$refs[formName].resetFields();
                this.checkboxGroup1 = [];
                this.checkboxGroup2 = [];
                this.checkboxGroup3 = [];
                this.checkboxGroup4 = [];
                this.checkboxGroup5 = [];
                this.checkboxGroup6 = [];
                this.checkboxGroup7 = [];
                this.checkboxGroup8 = [];
                this.checkboxGroup9 = [];
                this.checkboxGroup11= [];
                this.checkboxGroup12 = [];
                this.query = [];
                this.$set(this.pager,'page','1');
            },
            // 计算汇总求和
            getSummaries(param) {
                // param 是固定的对象，里面包含 columns与 data参数的对象 {columns: Array[4], data: Array[5]},包含了表格的所有的列与数据信息
                const { columns, data } = param;
                // console.log(param);
                // console.log(data)
                const sums = [];
                columns.forEach((column, index) => {
                    // console.log(column)
                    // console.log(index)
                    if (index === 0) {
                        sums[index] = '合计';
                        return;
                    }
                    if (index === 1) {
                        const values = data.map(item => Number(item[column.property]));
                        // 验证每个value值是否是数字，如果是执行if
                        if (!values.every(value => isNaN(value))) {
                            sums[index] = values.reduce((prev, curr) => {
                            // const value = Number(curr);
                            // if (!isNaN(value)) {
                            return prev + curr;
                            // } else {
                            //   return prev;
                            // }
                            }, 0);
                            sums[index] = sums[index].toFixed(2);
                        } else {
                            sums[index] = 'N/A';
                        }
                    }
                    if (index === 14) {
                        const values = data.map(item => Number(item[column.property]));
                        // 验证每个value值是否是数字，如果是执行if
                        if (!values.every(value => isNaN(value))) {
                            sums[index] = values.reduce((prev, curr) => {
                            // const value = Number(curr);
                            // if (!isNaN(value)) {
                            return prev + curr;
                            // } else {
                            //   return prev;
                            // }
                            }, 0);
                            sums[index] = Math.round(sums[index]);
                        } else {
                            sums[index] = 'N/A';
                        }
                    }
                    if (index === 15) {
                        const values = data.map(item => Number(item[column.property]));
                        // 验证每个value值是否是数字，如果是执行if
                        if (!values.every(value => isNaN(value))) {
                            sums[index] = values.reduce((prev, curr) => {
                            // const value = Number(curr);
                            // if (!isNaN(value)) {
                            return prev + curr;
                            // } else {
                            //   return prev;
                            // }
                            }, 0);
                            sums[index] = Math.round(sums[index]);
                        } else {
                            sums[index] = 'N/A';
                        }
                    }
                });
                return sums;
            },
            handleSuccess(res, file) {
                if (res.flag) {
                    if (res.code === 200) {
                        this.successMsg(res.msg);
                    }else if (res.code === 201) {
                        this.showMsg(res.msg);
                    }
                }else{
                    this.errorMsg(res.msg);
                }
                // console.log(res);
            },
            handleError(res, file){
                this.errorMsg('上传失败');
                // console.log(res);
                if ("502" == res.code) {
                    this.$router.push('/login');
                }
            },
            handlePreview(file) {
                console.log(file);
            },
            handleRemove(file, fileList) {
                console.log(file, fileList);
            },
            beforeUpload(file) {
                const extension = file.name.split(".")[1] === "xls";
                const extension2 = file.name.split(".")[1] === "xlsx";
                if (!extension && !extension2) {
                    alert('上传附件只能是xls/xlsx格式！');
                    return false;
                }
            },
            submitUpload() {
                // 第一种上传 ref
                this.$refs.upload.submit();
                this.fileList = [];
                this.dialogTableVisible001 = false;
            },
            // 时间格式化
            formatterDate(row, column) {
                if(row.deal_date){
                    return util.formatDate.format(new Date(row.deal_date), 'yyyy-MM-dd');
                }
            },
            getNowTime() {
                var now = new Date();
                var year = now.getFullYear();
                var month = now.getMonth();
                var date = now.getDate();
                month = month + 1;
                month = month.toString().padStart(2, '0');
                date = date.toString().padStart(2, '0');
                var defaultDate = `${year}-${month}-${date}`;
                return defaultDate;
            },
            // 根据rmb排序
            sortTableFun (column) {
                this.column = column.prop;
                if (column.prop) {
                    if (column.order == 'ascending') {
                        this.order = 'asc'
                    }else if (column.order == 'descending') {
                        this.order = 'desc'
                    }
                    this.selectDiamondInfoList();
                }
            },
            renderHeader (h, {column, $index }) {
                if (column.order == 'ascending') {
                    return h(
                        'div',
                        [
                            h('span',column.label),
                            h('i',{
                                class:'el-icon-sort-up'
                            })
                        ]
                    )
                }else if (column.order == 'descending') {
                    return h(
                        'div',
                        [
                            h('span',column.label),
                            h('i',{
                                class:'el-icon-sort-down'
                            })
                        ]
                    )
                } else {
                    return h(
                        'div',
                        [
                            h('span',column.label),
                            h('i',{
                                class:'el-icon-sort'
                            })
                        ]
                    )
                }
            },
            // 打开视频弹窗
            openVideoDialog(videoUrl) {
                this.currentVideoUrl = videoUrl;
                this.videoDialogVisible = true;
            },
            // 大视频配置
            getFullVideoOptions(video_link) {
                return {
                    playbackRates: [0.5, 1.0, 1.5, 2.0],
                    autoplay: true,
                    muted: false,
                    loop: true,
                    preload: 'auto',
                    language: 'zh-CN',
                    aspectRatio: '4:3',
                    fluid: true,
                    sources: [{
                        type: 'video/mp4',
                        src: video_link
                    }],
                    controlBar: {
                        timeDivider: true,
                        durationDisplay: true,
                        remainingTimeDisplay: true,
                        fullscreenToggle: true
                    }
                };
            }
        },
        mounted() {
            // 进入即默认展示90%比例
            // document.body.style.zoom = 0.9;
            this.user = sessionStorage.getItem('userName');
            this.selectListAll();
            this.selectDiamondInfoList();
            this.selectPlaceDictList();
            this.selectRateDictList();
            // console.log(this.url);
        },
        created(){
            // console.log(this.url);
        }
    };
</script>

<style lang="scss" scoped>
    /**奇偶行变色 */
    .el-table__row--striped td {
        background-color: #eaf3fb !important;
    }
    /** 修改表格行高 */
    .el-table .el-table__cell{
        padding: 3px 0px
    }
    /**修改排序图标位置 */
    .el-table .cell {
        position:relative;
    }
    /*.el-table .caret-wrapper {
        position: absolute;
        right: -8px;
        top:50%;
        transform: translateY(-50%);
    }*/
    .el-icon-round {
        background:url('../../assets/images/cut/round.png') center no-repeat;
        background-size: 40px 40px;
        width: 40px;
        height: 40px;
        margin: -9px;
        border-radius: 1px;
    }
    .el-icon-princess {
        background:url('../../assets/images/cut/princess.png') center no-repeat;
        background-size: 40px 40px;
        width: 40px;
        height: 40px;
        margin: -9px;
        border-radius: 1px;
    }
    .el-icon-radiant {
        background:url('../../assets/images/cut/radiant.png') center no-repeat;
        background-size: 40px 40px;
        width: 40px;
        height: 40px;
        margin: -9px;
        border-radius: 1px;
    }
    .el-icon-asscher {
        background:url('../../assets/images/cut/asscher.png') center no-repeat;
        background-size: 40px 40px;
        width: 40px;
        height: 40px;
        margin: -9px;
        border-radius: 1px;
    }
    .el-icon-marquise {
        background:url('../../assets/images/cut/marquise.png') center no-repeat;
        background-size: 40px 40px;
        width: 40px;
        height: 40px;
        margin: -9px;
        border-radius: 1px;
    }
    .el-icon-oval {
        background:url('../../assets/images/cut/oval.png') center no-repeat;
        background-size: 40px 40px;
        width: 40px;
        height: 40px;
        margin: -9px;
        border-radius: 1px;
    }
    .el-icon-emerald {
        background:url('../../assets/images/cut/emerald.png') center no-repeat;
        background-size: 40px 40px;
        width: 40px;
        height: 40px;
        margin: -9px;
        border-radius: 1px;
    }
    .el-icon-pear1 {
        background:url('../../assets/images/cut/pear1.png') center no-repeat;
        background-size: 40px 40px;
        width: 40px;
        height: 40px;
        margin: -9px;
        border-radius: 1px;
    }
    .el-icon-heart {
        background:url('../../assets/images/cut/heart.png') center no-repeat;
        background-size: 40px 40px;
        width: 40px;
        height: 40px;
        margin: -9px;
        border-radius: 1px;
    }
    .el-icon-cushion {
        background:url('../../assets/images/cut/cushion.png') center no-repeat;
        background-size: 40px 40px;
        width: 40px;
        height: 40px;
        margin: -9px;
        border-radius: 1px;
    }
    .el-icon-others {
        background:url('../../assets/images/cut/others.png') center no-repeat;
        background-size: 40px 40px;
        width: 40px;
        height: 40px;
        margin: -9px;
        border-radius: 1px;
    }
    .el-icon-triangle {
        background:url('../../assets/images/cut/triangle.png') center no-repeat;
        background-size: 40px 40px;
        width: 40px;
        height: 40px;
        margin: -9px;
        border-radius: 1px;
    }
    .el-dialog{
        display: flex;
        flex-direction: column;
        margin: 0 !important;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
    .el-dialog .el-dialog__body{
        flex: 1;
        overflow: auto;
    }
     /*:header-cell-style="{background:'#eee8aa'}"
    .el-table--border:after,
    .el-table--group:after,
    .el-table:before{
        background-color: #eee8aa
    }

    .el-table--border,
    .el-table--group{
        border-color: #eee8aa
    }

    .el-table td,
    .el-table th.is-leaf{
        border-bottom: #eee8aa
    }

    .el-table--border th,
    .el-table--border th.gutter:last-of-type{
        border-bottom: #eee8aa
    }

    .el-table--border td,
    .el-table--border th{
        border-right: #eee8aa
    }
    */
</style>



// WEBPACK FOOTER //
// src/pages/procurement/procurement.vue